// main startup function
import $ from "jquery";
import jqmunsued from "jquerymobile.config";
import jqm from "jquerymobile";
import _ from "underscore";
import Backbone from "backbone";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import { isLocalhostHostname } from "models/helper/LocalhostHelper";
import TrebbleIndexDBHelper from "models/helper/TrebbleIndexDBHelper";
import CordovaHelper from "models/helper/CordovaHelper";
import PlaylistHelper from "models/helper/PlaylistHelper";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import jqueryscrollstop from "jqueryscrollstop";
import jquerylazyload from "jquerylazyload";
import jqueryvisible from "jqueryvisible";
import Typeahead from "typeahead";
import Mention from "mention";
import notifyjs from "notifyjs";
import RSVP from "rsvp";
import Utils from "models/helper/Utils";
import ExpectedError, {
    EXPECTED_ERROR_CATEGORY,
    EXPECTED_ERROR_CLASSIFICATION,
} from "models/helper/ExpectedError";
import jqueryhoverintent from "jqueryhoverintent";
import MaterializeCss from "materializecss";
import nouislider from "nouislider";
import Pickadate from "pickadate";
import PickadateDate from "pickadateDate";
import PickadateTime from "pickadateTime";
import PickerTranslated from "libs/pickadate/picker.translated";
import MixpanelJS from "mixpanel";
import MParticleHelper from "models/helper/MParticleHelper";
import LiveChatWidgetHelper from "models/helper/LiveChatWidgetHelper";
import MixpanelHelper from "models/helper/MixpanelHelper";
import FeatureRolloutHelper from "models/helper/FeatureRolloutHelper";
import BrowserRecordingDraftStore from "models/helper/BrowserRecordingDraftStore";
import AdHelper from "models/helper/AdHelper";
import SubscriptionManager from "models/helper/SubscriptionManager";
import PersistentModels from "services/PersistentModels";
import Rollbar from 'rollbar';
import * as FullStory from '@fullstory/browser';
import owlcarousel from "owlcarousel";
import jqueryembedly from "jqueryembedly";
// Import React and ReactDOM to expose globally for test pages
import React from 'react';
import ReactDOM from 'react-dom/client';

function getDefaultExport(loadedModule){
  return loadedModule && loadedModule.default ? loadedModule.default : loadedModule;
}

let audioEditorTestHelpersPromise = null;

function resetAudioEditorTestHelpersReadyPromiseOnFailure(){
  audioEditorTestHelpersPromise = null;
  if(typeof window !== "undefined" && window.__AudioEditorTestHelpers){
    window.__AudioEditorTestHelpers.ready = null;
  }
}

const EXPECTED_NATIVE_ERROR_INFO_BY_NAME = {
    AbortError: {
        classification: EXPECTED_ERROR_CLASSIFICATION.NAVIGATION,
        expectedErrorCategory: EXPECTED_ERROR_CATEGORY.USER_ABORTED_BROWSER_OPERATION,
        watchInAnalytics: false,
    },
    EncodingError: {
        classification: EXPECTED_ERROR_CLASSIFICATION.USER_CONTENT,
        expectedErrorCategory: EXPECTED_ERROR_CATEGORY.AUDIO_DECODE_OR_UNSUPPORTED_FILE,
        watchInAnalytics: true,
    },
    NotAllowedError: {
        classification: EXPECTED_ERROR_CLASSIFICATION.VALIDATION,
        expectedErrorCategory: EXPECTED_ERROR_CATEGORY.BROWSER_PERMISSION_DENIED,
    },
    QuotaExceededError: {
        classification: EXPECTED_ERROR_CLASSIFICATION.ENVIRONMENT,
        expectedErrorCategory: EXPECTED_ERROR_CATEGORY.BROWSER_STORAGE_QUOTA_EXCEEDED,
        watchInAnalytics: true,
    },
};

const _truncateExpectedErrorValue = function(value){
    if(value === null || typeof value === "undefined"){
        return null;
    }
    const stringValue = String(value);
    return stringValue.length > 300 ? stringValue.substring(0, 300) : stringValue;
};

const _getExpectedErrorInfo = function(error){
    if(!error){
        return { isExpected: false };
    }
    let rawStatusCode = null;
    if(error && Object.prototype.hasOwnProperty.call(error, "httpStatus") && error.httpStatus !== null && typeof error.httpStatus !== "undefined" && error.httpStatus !== ""){
        rawStatusCode = error.httpStatus;
    }else if(error && Object.prototype.hasOwnProperty.call(error, "httpStatusCode") && error.httpStatusCode !== null && typeof error.httpStatusCode !== "undefined" && error.httpStatusCode !== ""){
        rawStatusCode = error.httpStatusCode;
    }else if(error && Object.prototype.hasOwnProperty.call(error, "statusCode") && error.statusCode !== null && typeof error.statusCode !== "undefined" && error.statusCode !== ""){
        rawStatusCode = error.statusCode;
    }else if(error && Object.prototype.hasOwnProperty.call(error, "status") && error.status !== null && typeof error.status !== "undefined" && error.status !== ""){
        rawStatusCode = error.status;
    }
    const explicitStatusCode = rawStatusCode === null || typeof rawStatusCode === "undefined" || rawStatusCode === "" ?
        null :
        Number(rawStatusCode);
    const nativeErrorInfo = error.name ? EXPECTED_NATIVE_ERROR_INFO_BY_NAME[error.name] : null;
    const normalizedNativeNetworkMessage = error.message ? String(error.message).trim().toLowerCase() : "";
    const isNativeNetworkError = error.name === "NetworkError" || (
        error.name === "TypeError" &&
        (
            normalizedNativeNetworkMessage === "network error" ||
            normalizedNativeNetworkMessage === "failed to fetch" ||
            normalizedNativeNetworkMessage === "load failed"
        )
    );
    const isExpectedErrorInstance = !!(
        (typeof ExpectedError === "function" && error instanceof ExpectedError) ||
        (typeof window !== "undefined" && window.ExpectedError && error instanceof window.ExpectedError) ||
        error.name === "ExpectedError" ||
        error.isNetworkError === true ||
        error.expectedErrorCategory ||
        nativeErrorInfo ||
        isNativeNetworkError
    );

    if(
        !isExpectedErrorInstance ||
        (Number.isFinite(explicitStatusCode) && explicitStatusCode >= 500 && explicitStatusCode < 600)
    ){
        return { isExpected: false };
    }

    return {
        isExpected: true,
        classification: error.classification || (nativeErrorInfo && nativeErrorInfo.classification) || (error.isNetworkError || isNativeNetworkError ? EXPECTED_ERROR_CLASSIFICATION.NETWORK : null),
        expectedErrorCategory: error.expectedErrorCategory || (nativeErrorInfo && nativeErrorInfo.expectedErrorCategory) || (error.isNetworkError || isNativeNetworkError ? EXPECTED_ERROR_CATEGORY.TRANSIENT_NETWORK_NO_RESPONSE : null),
        watchInAnalytics: !!(error.watchInAnalytics || (nativeErrorInfo && nativeErrorInfo.watchInAnalytics) || error.isNetworkError || isNativeNetworkError),
    };
};

window.getExpectedErrorInfo = _getExpectedErrorInfo;

window.trackExpectedErrorSkippedRollbar = function(error, source){
    try {
        if (!window.trebbleAnalyticsHelper) {
            return;
        }
        const expectedErrorInfo = _getExpectedErrorInfo(error);
        const metadata = {
            i18nKey: (error && error.i18nKey) || null,
            classification: expectedErrorInfo.classification,
            expectedErrorCategory: expectedErrorInfo.expectedErrorCategory,
            watchInAnalytics: expectedErrorInfo.watchInAnalytics,
            errorName: (error && error.name) || null,
            errorCode: (error && error.errorCode) || null,
            statusCode: error && Object.prototype.hasOwnProperty.call(error, "statusCode") ?
                error.statusCode :
                (
                    error && Object.prototype.hasOwnProperty.call(error, "httpStatus") ?
                        error.httpStatus :
                        (
                            error && Object.prototype.hasOwnProperty.call(error, "httpStatusCode") ?
                                error.httpStatusCode :
                                (
                                    error && Object.prototype.hasOwnProperty.call(error, "status") ?
                                        error.status :
                                        null
                                )
                        )
                ),
            source: (error && error.source) || source || null,
            reportingSource: source || null,
            message: _truncateExpectedErrorValue((error && error.message) || error),
        };
        window.trebbleAnalyticsHelper.trackEvent(
            "ErrorCollection",
            "ExpectedErrorSkippedRollbar",
            metadata.expectedErrorCategory || metadata.classification || metadata.errorName || "ExpectedError",
            null,
            metadata
        );
        if (metadata.watchInAnalytics) {
            window.trebbleAnalyticsHelper.trackEvent(
                "ErrorCollection",
                "ExpectedErrorWatchlist",
                metadata.expectedErrorCategory || metadata.classification || "expected_error_watchlist",
                null,
                metadata
            );
        }
    } catch (e) {
        console.error("Failed tracking ExpectedError skip. Error:" + e);
    }
};

function loadAudioEditorTestHelpers(){
  if(typeof window === "undefined"){
    return Promise.resolve(null);
  }
  if(audioEditorTestHelpersPromise){
    return audioEditorTestHelpersPromise;
  }
  window.__AudioEditorTestHelpers = window.__AudioEditorTestHelpers || {};
  // Expose a `ready` promise consumers can await so they can be sure the
  // full test-helper surface (paragraph builder, policy, ops, etc.) has
  // finished loading before accessing individual properties.
  audioEditorTestHelpersPromise = Promise.all([
    import("models/audioEditor/SelectionSpeakerChangeHelper"),
    import("models/audioEditor/ParagraphLayoutBuilder"),
    import("models/audioEditor/ParagraphBoundaryPreference"),
    import("models/audioEditor/createParagraphBoundaryPolicyForSequencer"),
    import("models/audioEditor/sequencerOperation/ChangeSpeakerForParagraphOperation"),
    import("models/audioEditor/sequencerOperation/ChangeParagraphBoundaryPreferenceOperation"),
    import("views/audioEditor/SequencerNodeMoreOptionContentView"),
    import("controllers/audioEditor/SequencerController"),
    import("views/audioEditor/SequencerView"),
    import("views/audioEditor/sequencerNodeView/SpeakerParagraphContainerView"),
    import("views/audioEditor/sequencerNodeView/UnlabeledParagraphContainerView"),
  ]).then((loadedModules)=>{
    const [
      SelectionSpeakerChangeHelper,
      ParagraphLayoutBuilder,
      ParagraphBoundaryPreference,
      createParagraphBoundaryPolicyForSequencer,
      ChangeSpeakerForParagraphOperation,
      ChangeParagraphBoundaryPreferenceOperation,
      SequencerNodeMoreOptionContentView,
      SequencerController,
      SequencerView,
      SpeakerParagraphContainerView,
      UnlabeledParagraphContainerView,
    ] = loadedModules.map(getDefaultExport);

    Object.assign(window.__AudioEditorTestHelpers, {
      SelectionSpeakerChangeHelper,
      ParagraphLayoutBuilder,
      ParagraphBoundaryPreference,
      createParagraphBoundaryPolicyForSequencer,
      ChangeSpeakerForParagraphOperation,
      ChangeParagraphBoundaryPreferenceOperation,
      SequencerNodeMoreOptionContentView,
      SequencerController,
      SequencerView,
      PersistentModels,
      SpeakerParagraphContainerView,
      UnlabeledParagraphContainerView,
      UnlabelledParagraphContainerView: UnlabeledParagraphContainerView,
    });
    return window.__AudioEditorTestHelpers;
  }).catch((error)=>{
    resetAudioEditorTestHelpersReadyPromiseOnFailure();
    console.error("[main] Failed to load audio editor test helpers", error);
    throw error;
  });
  window.__AudioEditorTestHelpers.ready = audioEditorTestHelpersPromise;
  return audioEditorTestHelpersPromise;
}

if (typeof window !== 'undefined') {
  // Expose React globally for test pages and external usage
  window.React = React;
  window.ReactDOM = ReactDOM;
  const shouldExposeAudioEditorTestHelpers = process.env.NODE_ENV !== "production"
    || (window.location && window.location.pathname && window.location.pathname.indexOf("/test-pages/") === 0);
  if(shouldExposeAudioEditorTestHelpers){
    // Expose targeted audio editor helpers for standalone browser harnesses.
    window.__AudioEditorTestHelpers = window.__AudioEditorTestHelpers || {};
    window.__AudioEditorTestHelpers.Backbone = Backbone;
    window.__AudioEditorTestHelpers.Utils = Utils;
    window.__AudioEditorTestHelpers.PersistentModels = PersistentModels;
    window.__TrebbleBrowserTestHelpers = window.__TrebbleBrowserTestHelpers || {};
    window.__TrebbleBrowserTestHelpers.openLoginPage = function(options = {}){
      window.__TrebbleBrowserTestHelpers.lastLoginOpenError = null;
      const loginPromise = TrebbleClientAPIHelper.getInstance().doLoginWithLoginPage(
        !!options.doNotCreateTempUserIfUserNotFound,
        true,
        options.successSignupData || null,
        !!options.forceSignUpAsCreator,
      );
      window.__TrebbleBrowserTestHelpers.pendingLoginPromise = loginPromise || null;
      if(loginPromise && typeof loginPromise.then === "function"){
        const clearPendingIfCurrent = function() {
          if(window.__TrebbleBrowserTestHelpers.pendingLoginPromise === loginPromise){
            window.__TrebbleBrowserTestHelpers.pendingLoginPromise = null;
          }
        };
        loginPromise.then(function() {
          clearPendingIfCurrent();
        }, function(error){
          if(window.__TrebbleBrowserTestHelpers.pendingLoginPromise === loginPromise){
            window.__TrebbleBrowserTestHelpers.lastLoginOpenError = error;
          }
          clearPendingIfCurrent();
          return null;
        });
      }
      return true;
    };
    // `ready` resolves once the async imports above finish, so harnesses
    // can `await window.__AudioEditorTestHelpers.ready` instead of polling
    // for individual properties.
    loadAudioEditorTestHelpers();
  }
}


const THIRD_PARTY_LIBRARIES_WITH_SIDE_EFFECTS = [
  jqmunsued,
  jqm,
  jqueryscrollstop,
  jquerylazyload,
  jqueryvisible,
  jqueryhoverintent,
  notifyjs,
  MaterializeCss,
  nouislider,
  Pickadate,
  PickadateDate,
  PickadateTime,
  PickerTranslated,
  MixpanelJS,
  owlcarousel,
  jqueryembedly,
  Typeahead,
  Mention
];// THIS ARRAY IS THERE TO MAKE SURE THAT THE LIBRARIES IN IT DOESN'T GET REMOVED FROM THE BUILD WEB PROCESS VIA WEBPACK TREE SHAKING - DO NOT REMOVE UNLESS THE LIBRARY USES ES6 IMPORT

const normalizeCrossOriginLocalhostHash = function () {
  const currentHash = window.location.hash || "";
  const rawHashValue = currentHash.length > 1 ? currentHash.substring(1).trim() : "";

  if (/^https?:\/\//i.test(rawHashValue)) {
    try {
      const parsedHashUrl = new URL(rawHashValue);
      if (
        !isLocalhostHostname(window.location.hostname) ||
        !isLocalhostHostname(parsedHashUrl.hostname) ||
        parsedHashUrl.origin === window.location.origin
      ) {
        return;
      }

      const normalizedHash = "#" + parsedHashUrl.pathname.replace(/^\/+/, "") + parsedHashUrl.search + parsedHashUrl.hash;
      const normalizedUrl = window.location.pathname + window.location.search + normalizedHash;

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", normalizedUrl);
      } else {
        window.location.hash = normalizedHash;
      }
      return;
    } catch (error) {
      console.error("Failed normalizing localhost hash redirect. Error:" + error);
      return;
    }
  }

  const pathname = window.location.pathname || "";
  const shouldNormalizeLocalhostPathRoute =
    isLocalhostHostname(window.location.hostname) &&
    !currentHash &&
    pathname &&
    pathname !== "/" &&
    pathname.indexOf(".") === -1;

  if (!shouldNormalizeLocalhostPathRoute) {
    return;
  }

  const normalizedPathRoute = pathname.replace(/^\/+/, "").replace(/\/+$/, "");
  if (!normalizedPathRoute) {
    return;
  }

  const inviteTokenPathRoutes = ["acceptWorkspace", "acceptWorkspaceInvite", "declineWorkspace", "declineWorkspaceInvite"];
  let normalizedHash = "#" + normalizedPathRoute + window.location.search;
  let normalizedSearch = "";
  if (inviteTokenPathRoutes.indexOf(normalizedPathRoute) !== -1 && window.location.search) {
    const searchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(window.location.search));
    const inviteToken = searchParams.get("token");
    if (inviteToken) {
      normalizedHash = "#" + normalizedPathRoute + "/" + encodeURIComponent(inviteToken);
      normalizedSearch = "";
    }
  }
  const normalizedUrl = (window.getAppBaseUrl ? window.getAppBaseUrl() : "/") + normalizedSearch + normalizedHash;

  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, "", normalizedUrl);
  } else {
    window.location.href = normalizedUrl;
  }
};

const getCurrentEntryPointHashWithoutHashSymbol = function () {
  if (window.location.hash) {
    return window.location.hash.substring(1);
  }

  const currentPathName = window.getPathNameWithoutHtmlPage ? window.getPathNameWithoutHtmlPage() : "";
  return currentPathName ? currentPathName.substring(1) : "";
};

const stripQueryAndNestedHashFromRouteFragment = function (routeFragment) {
  if (typeof routeFragment !== "string") {
    return "";
  }

  const trimmedRouteFragment = routeFragment.trim();
  if (!trimmedRouteFragment) {
    return "";
  }

  const queryIndex = trimmedRouteFragment.indexOf("?");
  const nestedHashIndex = trimmedRouteFragment.indexOf("#");
  let endIndex = trimmedRouteFragment.length;

  if (queryIndex !== -1) {
    endIndex = Math.min(endIndex, queryIndex);
  }

  if (nestedHashIndex !== -1) {
    endIndex = Math.min(endIndex, nestedHashIndex);
  }

  return trimmedRouteFragment.substring(0, endIndex);
};

const installBackboneRouteFragmentNormalization = function () {
  if (
    !Backbone ||
    !Backbone.History ||
    !Backbone.History.prototype ||
    Backbone.History.prototype._trebbleRouteFragmentNormalizationInstalled
  ) {
    return;
  }

  const originalGetFragment = Backbone.History.prototype.getFragment;
  Backbone.History.prototype.getFragment = function (fragment, forcePushState) {
    const resolvedFragment = originalGetFragment.call(this, fragment, forcePushState);
    return stripQueryAndNestedHashFromRouteFragment(resolvedFragment);
  };
  Backbone.History.prototype._trebbleRouteFragmentNormalizationInstalled = true;
};

installBackboneRouteFragmentNormalization();

const POST_LOGIN_REDIRECT_SESSION_KEY = "trebblePostLoginRedirectHash";
const persistPostLoginRedirectHash = function (routeHash) {
  const trimmedRouteHash = typeof routeHash === "string" ? routeHash.trim() : "";
  if (!trimmedRouteHash || trimmedRouteHash === "#NewLoginPage" || trimmedRouteHash === "#loginPage") {
    return null;
  }

  try {
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_SESSION_KEY, trimmedRouteHash.indexOf("#") === 0 ? trimmedRouteHash : `#${trimmedRouteHash}`);
  } catch (error) {
    console.error("Failed saving post-login redirect hash. Error:" + error);
  }

  return routeHash;
};

const executePendingHostedAuthAction = function (pendingAction) {
  const router = PersistentModels.getInstance().getRouter ? PersistentModels.getInstance().getRouter() : null;
  if (!router || !pendingAction || !pendingAction.type) {
    return RSVP.Promise.resolve(false);
  }

  const onPendingHostedAuthActionFailure = function (error) {
    if (error) {
      window.alertErrorMessage(error);
    }
  };

  switch (pendingAction.type) {
    case "subscribe_trebble":
      if (!pendingAction.trebbleId || !router.showSubscribeToTrebblePopupIfApplicable) {
        return RSVP.Promise.resolve(false);
      }

      return RSVP.Promise.resolve(
        router.showSubscribeToTrebblePopupIfApplicable(
          pendingAction.trebbleId,
          null,
          onPendingHostedAuthActionFailure,
          !!pendingAction.showThankYouMessage,
        ),
      );

    case "subscribe_journey":
      if (!pendingAction.journeyRadioId || !router.showSubscribeToJourneyPopupIfApplicable) {
        return RSVP.Promise.resolve(false);
      }

      return RSVP.Promise.resolve(
        router.showSubscribeToJourneyPopupIfApplicable(
          pendingAction.journeyRadioId,
          null,
          onPendingHostedAuthActionFailure,
          !!pendingAction.showThankYouMessage,
        ),
      );

    case "purchase_journey":
      if (!pendingAction.journeyRadioId || !router.showPurchaseJourneyPopup) {
        return RSVP.Promise.resolve(false);
      }

      return RSVP.Promise.resolve(
        router.showPurchaseJourneyPopup(
          pendingAction.journeyRadioId,
          null,
          onPendingHostedAuthActionFailure,
          !!pendingAction.showThankYouMessage,
        ),
      );

    default:
      return RSVP.Promise.resolve(false);
  }
};

const resumePendingHostedAuthActionIfApplicable = function () {
  if (
    !window.device ||
    window.device.platform != "browser" ||
    window.waitForCordovaToLoad
  ) {
    return RSVP.Promise.resolve(false);
  }

  const trebbleClientApi = TrebbleClientAPIHelper.getInstance();
  if (!trebbleClientApi || !trebbleClientApi.peekPendingHostedAuthAction) {
    return RSVP.Promise.resolve(false);
  }

  const searchParams = new URLSearchParams(
    Utils.getInstance().cleanQueryString(window.location.search || ""),
  );
  if (searchParams.get("authError") || searchParams.get("error")) {
    if (trebbleClientApi.clearPendingHostedAuthAction) {
      trebbleClientApi.clearPendingHostedAuthAction();
    }
    return RSVP.Promise.resolve(false);
  }

  const pendingHostedAuthAction = trebbleClientApi.peekPendingHostedAuthAction();
  if (!pendingHostedAuthAction || !Utils.getInstance().hasAuthenticatedNonVisitorSession()) {
    return RSVP.Promise.resolve(false);
  }

  const consumedPendingHostedAuthAction = trebbleClientApi.consumePendingHostedAuthAction ?
    trebbleClientApi.consumePendingHostedAuthAction() :
    pendingHostedAuthAction;

  if (!consumedPendingHostedAuthAction) {
    return RSVP.Promise.resolve(false);
  }

  return executePendingHostedAuthAction(consumedPendingHostedAuthAction);
};

const getBrowserRecordingDraftRecoveryPageOptions = function(recoverableDrafts) {
  const drafts = Array.isArray(recoverableDrafts) ? recoverableDrafts : [];
  const hasCapsuleDraft = drafts.some(function(draftManifest) {
    return draftManifest && draftManifest.originFlow === "capsule_creation";
  });
  const hasShortcastDraft = drafts.some(function(draftManifest) {
    return draftManifest && draftManifest.originFlow === "shortcast_creation";
  });
  const allDraftsAreRecordOnly = drafts.length > 0 && drafts.every(function(draftManifest) {
    return draftManifest && draftManifest.originFlow === "record_only";
  });

  return {
    useRecordOnlyRecoveryPage: allDraftsAreRecordOnly,
    createAShortcast: hasShortcastDraft || !hasCapsuleDraft,
  };
};

const completeRecoveredRecordOnlyDrafts = function(recordedFiles) {
  const filesToDownload = Array.isArray(recordedFiles) ? recordedFiles : [];

  filesToDownload.forEach(function(recordedFile, index) {
    if (!recordedFile) {
      return;
    }

    Utils.getInstance().downloadFile(
      recordedFile,
      recordedFile.name || `recovered-browser-recording-${index + 1}`,
    );
  });

  return RSVP.Promise.resolve(filesToDownload);
};

const promptForRecoverableBrowserRecordingDraftsIfApplicable = function(trebbleRouter) {
  if (
    !trebbleRouter ||
    !window.device ||
    window.device.platform != "browser" ||
    window.waitForCordovaToLoad
  ) {
    return RSVP.Promise.resolve(false);
  }

  const browserRecordingDraftStore = BrowserRecordingDraftStore.getInstance();
  const recoveryPromptUserId = browserRecordingDraftStore && browserRecordingDraftStore.getCurrentUserId ?
    (browserRecordingDraftStore.getCurrentUserId() || "anonymous") :
    "anonymous";
  window.trebble = window.trebble || {};
  window.trebble._didCheckBrowserRecordingDraftRecoveryPromptByUser = window.trebble._didCheckBrowserRecordingDraftRecoveryPromptByUser || {};
  if (window.trebble._didCheckBrowserRecordingDraftRecoveryPromptByUser[recoveryPromptUserId]) {
    return RSVP.Promise.resolve(false);
  }
  window.trebble._didCheckBrowserRecordingDraftRecoveryPromptByUser[recoveryPromptUserId] = true;

  const canAccessPersistedBrowserRecordingDrafts = !!(
    browserRecordingDraftStore &&
    (
      browserRecordingDraftStore.canAccessPersistedDrafts ?
        browserRecordingDraftStore.canAccessPersistedDrafts() :
        (browserRecordingDraftStore.isEnabled && browserRecordingDraftStore.isEnabled())
    )
  );

  if (!canAccessPersistedBrowserRecordingDrafts) {
    return RSVP.Promise.resolve(false);
  }

  const runDraftJanitorPromise = browserRecordingDraftStore.runConservativeJanitorForCurrentUser ?
    browserRecordingDraftStore.runConservativeJanitorForCurrentUser().catch(function(error) {
      console.warn("Failed running the browser recording draft janitor. Error:" + error);
      return null;
    }) :
    RSVP.Promise.resolve(null);

  return RSVP.Promise.resolve(runDraftJanitorPromise).then(function() {
    return browserRecordingDraftStore.listRecoverableDraftsForCurrentUser({
      includeDismissed: false,
    });
  }).then(function(recoverableDrafts) {
    if (!recoverableDrafts || recoverableDrafts.length === 0) {
      return false;
    }

    return RSVP.Promise.resolve(
      Utils.getInstance().showUserConfirmationDialog(
        "Recover unfinished recordings?",
        "We found unfinished browser recordings for this account.",
        "Reopen the recorder to recover or discard them.",
      ),
    ).then(function(userConfirmed) {
      if (!userConfirmed) {
        return RSVP.Promise.resolve(
          browserRecordingDraftStore.dismissDrafts(
            recoverableDrafts.map(function(draftManifest) {
              return draftManifest ? draftManifest.recordingId : null;
            }).filter(Boolean),
          ),
        ).then(function() {
          return false;
        });
      }

      const recoveryPageOptions = getBrowserRecordingDraftRecoveryPageOptions(recoverableDrafts);
      const recoveryOptions = {
        recoveryMode: true,
        recoverableDrafts: recoverableDrafts,
      };

      if (recoveryPageOptions.useRecordOnlyRecoveryPage && trebbleRouter.showAudioRecorderPage) {
        return RSVP.Promise.resolve(
          trebbleRouter.showAudioRecorderPage(
            completeRecoveredRecordOnlyDrafts,
            null,
            null,
            true,
            recoveryOptions,
          ),
        ).then(function() {
          return true;
        });
      }

      return RSVP.Promise.resolve(
        trebbleRouter.showAddAudioHightlightPageNew(
          null,
          null,
          null,
          null,
          true,
          true,
          null,
          null,
          null,
          true,
          null,
          true,
          recoveryPageOptions.createAShortcast,
          null,
          null,
          null,
          recoveryOptions,
        ),
      ).then(function() {
        return true;
      });
    });
  }).catch(function(error) {
    if(window.trebble && window.trebble._didCheckBrowserRecordingDraftRecoveryPromptByUser){
      delete window.trebble._didCheckBrowserRecordingDraftRecoveryPromptByUser[recoveryPromptUserId];
    }
    throw error;
  });
};

const syncTrebbleEntryPointAccessContext = function () {
  if (!window.trebble) {
    return null;
  }

  window.trebble.entryPointUrl = window.location.toString();
  window.trebble.entryPointUrlHash = window.location.hash ? window.location.hash : window.getPathNameWithoutHtmlPage();
  window.trebble.entryPointAllowsAnonymousView = false;
  window.trebble.entryPointRequiresAuthentication = false;
  window.trebble.allowAutoLoginAsGuest = false;
  window.trebble.entryPointUrlHashLoadedPlayerQueue = false;
  window.trebble.allowEasySignupForListenersAtLogin = false;

  if (!(window.device && window.device.platform == "browser" && (window.getPathNameWithoutHtmlPage() || window.location.hash))) {
    return null;
  }

  const hashWithoutHashSymbol = getCurrentEntryPointHashWithoutHashSymbol();
  const routeFragmentForMatching = stripQueryAndNestedHashFromRouteFragment(hashWithoutHashSymbol);
  const routeInfoArray = (Router && Router.prototype && Router.prototype.routeRegexMappedToGuestLoginAllowed) ?
    Router.prototype.routeRegexMappedToGuestLoginAllowed :
    [];

  for (let ii = 0; ii < routeInfoArray.length; ii++) {
    const routeInfo = routeInfoArray[ii];
    if (!routeInfo || !routeInfo.regex || !routeInfo.regex.test(routeFragmentForMatching)) {
      continue;
    }

    const shouldAllowAutoLoginAsGuest =
      !window.waitForCordovaToLoad &&
      !Utils.getInstance().isBrowserHostedAuthEnvironment() &&
      !!routeInfo.allowAutoLoginAsGuest;

    window.trebble.entryPointAllowsAnonymousView = !!routeInfo.isGuestLoginAllowed;
    window.trebble.entryPointRequiresAuthentication = !!routeInfo.requiresAuthenticatedNonVisitorSession;
    window.trebble.allowAutoLoginAsGuest = window.waitForCordovaToLoad ? false : shouldAllowAutoLoginAsGuest;
    window.trebble.entryPointUrlHashLoadedPlayerQueue = window.waitForCordovaToLoad ? false : routeInfo.loadPlayerQueue;
    window.trebble.allowEasySignupForListenersAtLogin = !!routeInfo.allowEasySignupForListenersAtLogin;

    if (window.trebble.isAccessCodePreset) {
      window.trebble.presetAccessCode = FREE_ACCESS_CODE_FOR_USER_WHO_DISCOVER_TREBBLE_VIA_SHARED_LINK;
    }

    if (routeInfo.isReferrerPassedInUrl) {
      const urlArguments = routeFragmentForMatching.match(routeInfo.regex);
      const encodedPassedReferrer = urlArguments ? urlArguments[routeInfo.referrerArgumentIndex + 1] : undefined;
      if (typeof encodedPassedReferrer !== "undefined") {
        if (encodedPassedReferrer) {
          try {
            window.trebble.referrer = decodeURIComponent(encodedPassedReferrer);
          } catch (error) {
            console.error("Failed decoding passed referrer. Error:" + error);
          }
        }
      }
    }

    return routeInfo;
  }

  return null;
};

const hasAuthenticatedNonVisitorBrowserSession = function () {
  return Utils.getInstance().hasAuthenticatedNonVisitorSession();
};

const shouldDeferHostedBrowserSessionReconciliation = function () {
  if (
    !window.device ||
    window.device.platform != "browser" ||
    window.waitForCordovaToLoad ||
    !Utils.getInstance().isBrowserHostedAuthEnvironment()
  ) {
    return false;
  }

  if (hasAuthenticatedNonVisitorBrowserSession()) {
    return false;
  }

  const localStorageHelper = LocalStorageHelper.getInstance ? LocalStorageHelper.getInstance() : null;
  return !!(
    localStorageHelper &&
    localStorageHelper.hasHostedBrowserAuthenticatedSessionHint &&
    localStorageHelper.hasHostedBrowserAuthenticatedSessionHint()
  );
};

const bootstrapHostedBrowserSessionIfLikelyAuthenticated = function (onResolvedUnauthenticated) {
  if (!shouldDeferHostedBrowserSessionReconciliation()) {
    return RSVP.Promise.resolve(false);
  }

  bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks =
    bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks || [];
  if (typeof onResolvedUnauthenticated == "function") {
    bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks.push(onResolvedUnauthenticated);
  }

  if (bootstrapHostedBrowserSessionIfLikelyAuthenticated._promise) {
    return bootstrapHostedBrowserSessionIfLikelyAuthenticated._promise;
  }

  const runPendingUnauthenticatedCallbacks = function() {
    const pendingCallbacks = bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks || [];
    bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks = [];
    pendingCallbacks.forEach(function(pendingCallback) {
      try {
        pendingCallback();
      } catch (callbackError) {
        console.warn("Hosted browser session unauthenticated callback failed. Error:" + callbackError);
      }
    });
  };

  bootstrapHostedBrowserSessionIfLikelyAuthenticated._promise = RSVP.Promise.resolve(TrebbleClientAPIHelper.getInstance().bootstrapWebSession())
    .then(function () {
      const hasAuthenticatedSession = hasAuthenticatedNonVisitorBrowserSession();
      if (!hasAuthenticatedSession) {
        const localStorageHelper = LocalStorageHelper.getInstance ? LocalStorageHelper.getInstance() : null;
        if (localStorageHelper && localStorageHelper.clearHostedBrowserAuthenticatedSessionHint) {
          localStorageHelper.clearHostedBrowserAuthenticatedSessionHint();
        }

        runPendingUnauthenticatedCallbacks();
      }

      return hasAuthenticatedSession;
    })
    .catch(function (error) {
      console.warn("Hosted browser session reconciliation failed while deferring auth navigation. Error:" + error);
      const localStorageHelper = LocalStorageHelper.getInstance ? LocalStorageHelper.getInstance() : null;
      if (localStorageHelper && localStorageHelper.clearHostedBrowserAuthenticatedSessionHint) {
        localStorageHelper.clearHostedBrowserAuthenticatedSessionHint();
      }

      runPendingUnauthenticatedCallbacks();

      return false;
    })
    .then(function(result) {
      if(result){
        bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks = [];
      }
      bootstrapHostedBrowserSessionIfLikelyAuthenticated._promise = null;
      return result;
    }, function(error) {
      bootstrapHostedBrowserSessionIfLikelyAuthenticated._pendingUnauthenticatedCallbacks = [];
      bootstrapHostedBrowserSessionIfLikelyAuthenticated._promise = null;
      throw error;
    });

  return bootstrapHostedBrowserSessionIfLikelyAuthenticated._promise;
};

const getBrowserLoginRedirectUrl = function () {
  const appBaseUrl = window.getAppBaseUrl ? window.getAppBaseUrl() : "/";

  try {
    return new URL(appBaseUrl, window.location.origin).toString() + "#NewLoginPage";
  } catch (error) {
    const normalizedBaseUrl = typeof appBaseUrl === "string" && appBaseUrl ? appBaseUrl : "/";
    return window.location.origin + normalizedBaseUrl + "#NewLoginPage";
  }
};

const handleUnauthenticatedBrowserEntryPoint = function (previousEntryPointUrlHash, currentEntryPointUrlHash) {
  const shouldForceProtectedBrowserRouteBackToLogin =
    window.device &&
    window.device.platform == "browser" &&
    !window.waitForCordovaToLoad &&
    window.trebble.routerReady &&
    !window.trebble.isEmbededLoginInPage &&
    window.trebble.entryPointRequiresAuthentication &&
    !hasAuthenticatedNonVisitorBrowserSession();

  if (shouldForceProtectedBrowserRouteBackToLogin) {
    const loginRedirectUrl = getBrowserLoginRedirectUrl();
    if (window.location.hash !== "#NewLoginPage" && loginRedirectUrl) {
      persistPostLoginRedirectHash(currentEntryPointUrlHash || previousEntryPointUrlHash);
      window.location.replace(loginRedirectUrl);
      return true;
    }

    const currentRouter = PersistentModels.getInstance().getRouter();
    if (currentRouter && currentRouter.showNewLoginPage) {
      currentRouter.showNewLoginPage(false);
      return true;
    }
  }

  const shouldReloadLoggedOutBrowserShell =
    window.device &&
    window.device.platform == "browser" &&
    !window.waitForCordovaToLoad &&
    !window.trebble.routerReady &&
    !window.trebble.isEmbededLoginInPage &&
    previousEntryPointUrlHash !== currentEntryPointUrlHash;

  if (shouldReloadLoggedOutBrowserShell) {
    persistPostLoginRedirectHash(currentEntryPointUrlHash || previousEntryPointUrlHash);
    window.location.reload();
    return true;
  }

  return false;
};

const getHostedBrowserShellReturnUrl = function () {
  const appBaseUrl = window.getAppBaseUrl ? window.getAppBaseUrl() : "/";

  try {
    const normalizedAppUrl = new URL(appBaseUrl, window.location.origin);
    const normalizedBaseUrl = normalizedAppUrl.toString();
    const currentHash = window.location.hash || "";

    if (currentHash && currentHash !== "#") {
      return normalizedBaseUrl + currentHash;
    }

    let currentRoutePath = window.location.pathname || "";
    const normalizedBasePath = normalizedAppUrl.pathname || "/";

    if (normalizedBasePath !== "/" && currentRoutePath.indexOf(normalizedBasePath) === 0) {
      currentRoutePath = currentRoutePath.substring(normalizedBasePath.length);
    }

    currentRoutePath = currentRoutePath.replace(/^\/+/, "");
    if (currentRoutePath) {
      return normalizedBaseUrl + "#" + currentRoutePath;
    }

    return normalizedBaseUrl;
  } catch (error) {
    console.error("Failed building hosted browser return URL. Error:" + error);
    return window.location.origin + appBaseUrl + (window.location.hash || "");
  }
};

const redirectHostedBrowserAuthCodeToCallbackIfApplicable = function () {
  if (
    !window.device ||
    window.device.platform != "browser" ||
    window.waitForCordovaToLoad ||
    (window.location.protocol !== "http:" && window.location.protocol !== "https:")
  ) {
    return false;
  }

  if (!Utils.getInstance().isBrowserHostedAuthEnvironment()) {
    return false;
  }

  const searchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(window.location.search));
  if (!searchParams.get("code")) {
    return false;
  }

  const trebbleClientApi = TrebbleClientAPIHelper.getInstance();
  if (!trebbleClientApi || !trebbleClientApi._getApiBaseUrl) {
    return false;
  }

  let callbackUrl;
  try {
    callbackUrl = new URL(trebbleClientApi._getApiBaseUrl().replace(/\/+$/, "") + "/auth/callback");
  } catch (error) {
    console.error("Failed building hosted auth callback URL. Error:" + error);
    return false;
  }

  if (window.location.origin === callbackUrl.origin && window.location.pathname === callbackUrl.pathname) {
    return false;
  }

  searchParams.forEach(function (value, key) {
    callbackUrl.searchParams.set(key, value);
  });

  if (!callbackUrl.searchParams.get("returnTo")) {
    callbackUrl.searchParams.set("returnTo", getHostedBrowserShellReturnUrl());
  }

  window.location.replace(callbackUrl.toString());
  return true;
};

const handleBrowserEntryPointHashChange = function () {
  const previousEntryPointUrlHash =
    window.trebble && window.trebble.entryPointUrlHash ? window.trebble.entryPointUrlHash : "";

  syncTrebbleEntryPointAccessContext();

  const currentEntryPointUrlHash =
    window.trebble && window.trebble.entryPointUrlHash ? window.trebble.entryPointUrlHash : "";

  if (shouldDeferHostedBrowserSessionReconciliation()) {
    bootstrapHostedBrowserSessionIfLikelyAuthenticated(function () {
      handleUnauthenticatedBrowserEntryPoint(previousEntryPointUrlHash, currentEntryPointUrlHash);
    });
    return;
  }

  if (handleUnauthenticatedBrowserEntryPoint(previousEntryPointUrlHash, currentEntryPointUrlHash)) {
    return;
  }
};

window.syncTrebbleEntryPointAccessContext = syncTrebbleEntryPointAccessContext;


//"controllers/audioHighlight/RecordAudioHightlightPageNewController",
//"controllers/audioEditor/AudioEditorDemoPageController",
//"libs/webAudioApiShim/web-audio-api-shim",
//import TippyJS from "tippyJS";



//"libs/wavesurfer/wavesurfer",
/*"libs/wavesurfer/wavesurfer.cursor.min",
"libs/wavesurfer/wavesurfer.minimap.min",
"libs/wavesurfer/wavesurfer.regions.min",*/
//"segmentjs",
import Router from "Router";

//"services/SongIdentificationService",
import basicNotificationTemplate from "text!../templates/notifyjs/basicNotificationTemplate.html";

import Utilsi18n from "i18n!nls/Utilsi18n";

//Adding the following library in the first load although there are not required but I mostly used by first time user so it best that it is loaded by default
//"controllers/common/SongTabManagerPopupController",
//import hammerjs from "hammerjs";//,
//"fb"
//"positionSticky",



var TOKEN_PREFIX_IN_HASH = "#token/";
var TOKEN_PREFIX_IN_PATHNAME = "/token/";
var ACCESS_CODE_PREFIX_IN_HASH = "#accessCode/";
var ACCESS_CODE_PREFIX_IN_PATHNAME = "/accessCode/";
var AD_REF_PREFIX_IN_HASH = "#adRef/";
var AD_REF_PREFIX_IN_PATHNAME = "/adRef/";
var FORCE_AUTH = "#forceauth";
var CUSTOM_APP_ACCESS_CODE ="2E62-C3SR-C3FI";
var FREE_ACCESS_CODE_FOR_USER_WHO_DISCOVER_TREBBLE_VIA_SHARED_LINK =  "A238-7HZH-9YCL";
var DO_NO_SYNC_USER_TREBBLE_SONG_LIST_OVER_THIS_NUMBER_OF_SONGS =  2000;
var FORWARD_URL_SEGMENT = "/forward_url/";
var AUTH_FREE_STARTUP_ROUTE_PREFIXES = ["acceptGuestInvite", "acceptWorkspace", "acceptWorkspaceInvite", "declineWorkspace", "declineWorkspaceInvite", "signupForAudioEditor", "newSignupPage", "onboardingSignupPage", "loginForAudioEditor", "NewLoginPage", "loginPage", "resetPassword", "reset-password"];

var getCurrentRouteFragment = function(){
	if(location.hash){
		return location.hash.replace(/^#/, "");
	}
	// Fallback: when a URL like "/#acceptWorkspaceInvite?token=XYZ" gets
	// normalized during startup so that ?token=... ends up on location.search
	// while the hash is cleared, derive the route fragment from the full
	// href so auth-free startup still kicks in.
	if(location.href){
		var match = location.href.match(/#([^?]+)/);
		if(match && match[1]){
			return match[1];
		}
	}
	var pathNameWithoutHtmlPage = window.getPathNameWithoutHtmlPage();
	return pathNameWithoutHtmlPage ? pathNameWithoutHtmlPage.replace(/^\//, "") : "";
};

// Public hosted-auth entry routes must render without re-entering authenticated bootstrap.
var shouldSkipAuthenticatedStartupBootstrapForCurrentRoute = function(){
	if(LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor()){
		return false;
	}
	if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
		var currentRouteInfo = syncTrebbleEntryPointAccessContext();
		if(currentRouteInfo && currentRouteInfo.isGuestLoginAllowed && !currentRouteInfo.requiresAuthenticatedNonVisitorSession){
			return true;
		}
	}
	var currentRouteFragment = getCurrentRouteFragment();
	for(let ii in AUTH_FREE_STARTUP_ROUTE_PREFIXES){
		if(currentRouteFragment.indexOf(AUTH_FREE_STARTUP_ROUTE_PREFIXES[ii]) === 0){
			return true;
		}
	}
	return false;
};


const isDevEnvironement = location.hostname === "localhost" || location.hostname === "127.0.0.1";
const isProductionMainBranch = process.env.BRANCH === "master"?true:false;
window._createSafeRollbarPersonPayload = function(userId, userInfo){
	const safePersonPayload = {};
	const addTrackingFieldIfPresent = function(target, key, value){
		if(value !== undefined && value !== null && value !== ""){
			target[key] = value;
		}
	};
	const resolvedUserId = userId || (userInfo && userInfo._id);
	addTrackingFieldIfPresent(safePersonPayload, "id", resolvedUserId);
	addTrackingFieldIfPresent(safePersonPayload, "username", userInfo && userInfo.username);
	addTrackingFieldIfPresent(safePersonPayload, "profileType", userInfo && userInfo.profileType);
	addTrackingFieldIfPresent(safePersonPayload, "temporary", userInfo && userInfo.temporary);
	return Object.keys(safePersonPayload).length ? safePersonPayload : null;
};
window._redactRollbarNetworkUrl = function(urlValue){
	if(typeof urlValue !== "string" || urlValue.indexOf("?") === -1){
		return urlValue;
	}
	try{
		const parsedUrl = new URL(urlValue, window.location && window.location.origin ? window.location.origin : undefined);
		if(parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:"){
			return urlValue;
		}
		parsedUrl.search = "?redacted=1";
		parsedUrl.hash = "";
		return parsedUrl.toString();
	}catch(error){
		const queryStringIndex = urlValue.indexOf("?");
		return queryStringIndex === -1 ? urlValue : urlValue.substr(0, queryStringIndex) + "?redacted=1";
	}
};
window._sanitizeRollbarPayloadBeforeSend = function(payload){
	if(!payload){
		return payload;
	}
	if(payload.person){
		payload.person = window._createSafeRollbarPersonPayload(payload.person.id || payload.person._id, payload.person);
	}
	if(payload.request){
		payload.request.url = window._redactRollbarNetworkUrl(payload.request.url);
		if(payload.request.query_string){
			payload.request.query_string = "redacted=1";
		}
	}
	if(payload.notifier && payload.notifier.configured_options && payload.notifier.configured_options.payload && payload.notifier.configured_options.payload.person){
		payload.notifier.configured_options.payload.person = window._createSafeRollbarPersonPayload(
			payload.notifier.configured_options.payload.person.id || payload.notifier.configured_options.payload.person._id,
			payload.notifier.configured_options.payload.person
		);
	}
	const telemetry = payload.body && payload.body.telemetry;
	if(Array.isArray(telemetry)){
		telemetry.forEach(function(telemetryEntry){
			if(telemetryEntry && telemetryEntry.body && telemetryEntry.body.url){
				telemetryEntry.body.url = window._redactRollbarNetworkUrl(telemetryEntry.body.url);
			}
		});
	}
	return payload;
};
//Init Rollbar
const rollbar = new Rollbar({
	accessToken: isProductionMainBranch?'5e2b4d629b894bc388f8c83414a4ae00':'06e92ee0edeb4b0b96004634f7da5c23',
	enabled: (location.hostname === "localhost" || location.hostname === "127.0.0.1" || (location.pathname && location.pathname.startsWith("/trebble_embedded_optimized.html")))?false: true,
	captureUncaught: true,
	captureUnhandledRejections: true,
	payload: {
		environment: (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")?"Development":"Production",
		// context: 'rollbar/test'
		client: {
		javascript: {
			code_version: window.trebbleAppVersion,
			// source_map_enabled: true,
			// guess_uncaught_frames: true
			}
		}
	},
	// Session Replay configuration
	recorder: {
		enabled: true,
		autostart: true,
		maxSeconds: 300, // 5 minutes max recording
		triggers: ['error', 'critical'], // Only record on errors
		baseSamplingRatio: 1.0, // 100% sampling when errors occur
		
		// Privacy settings - important for user data protection
		maskAllInputs: true, // Mask all input fields by default
		maskInputOptions: {
			password: true,
			email: true
		},
		// Block sensitive areas from recording
		blockSelector: '.payment-form, .credit-card-input, #stripe-element',
		// Mask text in sensitive areas
		maskTextSelector: '.user-email, .user-password, input[type="password"], input[type="email"]',
		
		// Optional: Enable debug mode during testing
		// debug: {
		//     logEmits: true
			// }
	},
	checkIgnore: function(isUncaught, args, payload) {
		try {
			const exception = payload && payload.body && payload.body.trace && payload.body.trace.exception ? payload.body.trace.exception : null;
			const exceptionClass = exception && exception.class ? exception.class : "";
			const exceptionMessage = exception && exception.message ? exception.message : "";
			const exceptionMessageTrimmed = exceptionMessage.trim();
			const exceptionMessageLower = exceptionMessage.toLowerCase();
			const exceptionMessageTrimmedLower = exceptionMessageTrimmed.toLowerCase();
			const ignoredBootstrapMessageByText = {
				"download failed": true,
				"download failed.": true,
				"hardware acceleration required": true,
				"invalid invite link": true,
				"invalid invite token": true,
				"invalid or already used invite token": true,
				"no trebble was found!": true,
				"oops! unauthorised transaction": true,
				"please login!": true,
				"request timedout after 0 seconds": true,
				"script error.": true,
				"something went wrong while transcribing your audio": true,
				"unable to find this channel": true,
				"we encountered an error. please try re-uploading the file for transcription.": true,
				"you do not have access to this project": true,
				"your audio couldn't be loaded. please try another file.": true,
			};
			const requestUrl = payload && payload.request && payload.request.url ? payload.request.url : "";
			const isPreviewOrLocalUrl = function(value){
				const valueLower = String(value || "").toLowerCase();
				return valueLower.indexOf("://localhost") !== -1 ||
					valueLower.indexOf("://127.0.0.1") !== -1 ||
					valueLower.indexOf("://10.") !== -1 ||
					/:\/\/172\.(1[6-9]|2\d|3[01])\./.test(valueLower) ||
					valueLower.indexOf("://192.168.") !== -1 ||
					valueLower.indexOf(".amplifyapp.com") !== -1 ||
					valueLower.indexOf("pr-") !== -1;
			};
			const serializedExpectedError = exception ? { name: exceptionClass, message: exceptionMessage } : null;
			if(serializedExpectedError && Object.prototype.hasOwnProperty.call(exception, "httpStatusCode")){
				serializedExpectedError.httpStatusCode = exception.httpStatusCode;
			}
			if(serializedExpectedError && Object.prototype.hasOwnProperty.call(exception, "statusCode")){
				serializedExpectedError.statusCode = exception.statusCode;
			}
			if(serializedExpectedError && Object.prototype.hasOwnProperty.call(exception, "status")){
				serializedExpectedError.status = exception.status;
			}
			const serializedExpectedErrorInfo = _getExpectedErrorInfo(serializedExpectedError);
			const originalArgs = args || [];
			let hasOnlyTrustedDomEventArg = false;
			for(let originalArgIndex = 0; originalArgIndex < originalArgs.length; originalArgIndex++){
				const originalArg = originalArgs[originalArgIndex];
				if(
					originalArg &&
					typeof originalArg === "object" &&
					originalArg.isTrusted === true &&
					typeof originalArg.message === "undefined" &&
					typeof originalArg.error === "undefined" &&
					typeof originalArg.reason === "undefined" &&
					typeof originalArg.stack === "undefined" &&
					typeof originalArg.name === "undefined"
				){
					hasOnlyTrustedDomEventArg = true;
					break;
				}
			}
			if(exceptionClass === "(unknown)" && exceptionMessage === "{\"isTrusted\":true}" && hasOnlyTrustedDomEventArg){
				return true;
			}
			let expectedErrorArg = null;
			let hasReportableExpectedErrorArg = false;
			for(let i = 0; i < originalArgs.length; i++){
				const originalArg = originalArgs[i];
				const originalArgExpectedErrorInfo = _getExpectedErrorInfo(originalArg);
				if(originalArgExpectedErrorInfo.isExpected){
					expectedErrorArg = originalArg;
					break;
				}
				if(
					originalArg &&
					(
						originalArg.name === "ExpectedError" ||
						originalArg.isNetworkError === true ||
						originalArg.expectedErrorCategory
					)
				){
					hasReportableExpectedErrorArg = true;
				}
			}
			if(expectedErrorArg || (serializedExpectedErrorInfo.isExpected && !hasReportableExpectedErrorArg)){
				if(window.trackExpectedErrorSkippedRollbar){
					window.trackExpectedErrorSkippedRollbar(
						expectedErrorArg || serializedExpectedError,
						isUncaught ? "rollbar_uncaught" : "rollbar_handled"
					);
				}
				return true;
			}
			if(
				ignoredBootstrapMessageByText[exceptionMessageTrimmedLower] ||
				exceptionMessageLower.indexOf("try re-uploading the file for transcription") !== -1 ||
				(exceptionMessage.indexOf("Syntax error, unrecognized expression:") !== -1 && exceptionMessage.indexOf("%2F") !== -1) ||
				(exceptionMessage.indexOf("Failed to execute 'pushState' on 'History'") !== -1 && isPreviewOrLocalUrl(exceptionMessage + " " + requestUrl)) ||
				(exceptionMessageTrimmed === "Could not create workspace" && isPreviewOrLocalUrl(requestUrl))
			){
				return true;
			}
		} catch(error) {
			console.error("Failed checking Rollbar ignored error. Error:" + error);
		}
		return false;
	},
	transform: function(payload) {
		try {
			window._sanitizeRollbarPayloadBeforeSend(payload);
			// Add Mixpanel session replay URL
			if (window.MixpanelTrebbleHelper) {
				const mixpanelReplayUrl = window.MixpanelTrebbleHelper.getSessionReplayUrl();
				if (mixpanelReplayUrl) {
					payload.custom = payload.custom || {};
					payload.custom.mixpanelSessionReplayUrl = mixpanelReplayUrl; // Renamed to be more specific
				}
			}

			// Add FullStory session URL
			if (window.FS && typeof window.FS.getCurrentSessionURL === 'function') {
				const fullStorySessionUrl = window.FS.getCurrentSessionURL();
				if (fullStorySessionUrl) {
					payload.custom = payload.custom || {};
					payload.custom.fullStorySessionUrl = fullStorySessionUrl;
				}
			}
			
			// Add Rollbar Session Replay URL if available
			if (window.Rollbar && typeof window.Rollbar.getSessionUrl === 'function') {
				const rollbarSessionUrl = window.Rollbar.getSessionUrl();
				if (rollbarSessionUrl) {
					payload.custom = payload.custom || {};
					payload.custom.rollbarSessionReplayUrl = rollbarSessionUrl;
				}
			}
			window._sanitizeRollbarPayloadBeforeSend(payload);
		} catch (e) {
			// Suppress errors during transform to avoid recursive error reporting
			console.error("Error adding session URLs to Rollbar payload:", e);
		}
	},
});

window.Rollbar = rollbar;


//Init FullStory

FullStory.init({
  orgId: "85EHD",
  namespace: "FS",
  script: "edge.fullstory.com/s/fs.js",
  host: "fullstory.com",
  debug: false,
  devMode: isDevEnvironement,
});


//IMPORTANT:::
//THIS IS A TEMPORARY HACK ALLOWING PEOPLE THAT HAVE A SHARE LINK 
//TO PLAY A TREBBLE WITHOUT AN ACCOUNT OR IF IT IS EMBEDDED
var arrayOfPrefixHashWithAutoLoginAllowed = ["#player/action/load/", "#player/action/play/","#p/p/","#p/l/"];
//var arrayOfPrefixHashWithReferrerPassingSupport = ["#p/p/","#p/l/"];
var arrayOfPrefixWithQuickStartMode = ["#addSongToTrebble", "#public", "#ExplorePage"];

//Attach MixpanelJS to window context in order to use it anywhere without requireJS
//window.MixpanelJS = MixpanelJS;
window.MParticleTrebbleHelper = MParticleHelper.getInstance();
window.MixpanelTrebbleHelper = MixpanelHelper.getInstance();
var Rollout = FeatureRolloutHelper.getInstance();




document.triggerEventFromDocument =  function(eventName, params){
    try{
        $(document).trigger(eventName,{"params": params});
    }catch(error){
        console.error(error);
    }
}

var analyseAllUnIdentifiedSongs = function(){
    return TrebbleIndexDBHelper.getInstance().getNextSongToIdify().then(function(songs){
        if(songs && (!Array.isArray(songs) || songs.length > 0))
        {
    //window.log("The songs to identify is :"+ JSON.stringify(results));
            if(Array.isArray(songs))
            {
                return analyseSongs(songs, 0);
            }
        }
        window.log("All songs have been identified successfully. Date : "+ new Date().getTime());
        return  null;
    })
};

var analyseSongs =function(songArray , index){
    if(songArray && songArray.length > index && isSongNeedToBeIdentified(songArray[index])){
        var song = songArray[index];
        var songUri = song.uri;
        return scanSongAndUpdateDb(songUri).then(function(){
            return analyseSongs(songArray, index+1);
        });
    }else{
        window.log("All songs have been identified successfully. Date : "+ new Date().getTime());
        return RSVP.Promise.resolve();
    }

};

var isSongNeedToBeIdentified= function(song){
    var currentTime =  (new Date()).getTime();
    var sevenDaysMilliseconds  = 3600*100*24*7;
    if(song && song.type == "localFile" && !song.idifiedSuccess &&(!song.idifiedDate || ((currentTime - song.idifiedDate.getTime()) > sevenDaysMilliseconds))){
        return true;
    }else{
        return false;
    }
};


var scanSongAndUpdateDb = function(songUri){
    var idifiedSongInfo = null;
    return CordovaHelper.getInstance().executePluginOperation("MusicFileReaderPlugin","analyseAudioFileForUrl", [songUri]).then(function(idifiedInfo){
        idifiedSongInfo = (idifiedInfo && idifiedInfo != "OK" && idifiedInfo != {} )?idifiedInfo : null;
        if(idifiedSongInfo){
    //NEED TO CALL SERVER TO TRY TO GET AN APPROXIMATE RELEASE DATE
            return requirePromise(["services/SongIdentificationService"]).then((function(SongIdentificationService){
                return SongIdentificationService.getInstance().addPossibleReleaseDateToIdifiedInfo(idifiedSongInfo);
            }).bind(this)).then((function(updatedIdifiedSongInfo){
                idifiedSongInfo = updatedIdifiedSongInfo;
                return TrebbleIndexDBHelper.getInstance().getSongWithURI(songUri);
            }).bind(this)).catch((function(error){
        //Should never get there anyway
                return TrebbleIndexDBHelper.getInstance().getSongWithURI(songUri);
            }).bind(this));

        }
        return TrebbleIndexDBHelper.getInstance().getSongWithURI(songUri);
    }).then(function(songFound){
        var context  = Utils.getInstance().buildContextForSongCollectionMyLibrary();
        if(songFound){
            if(idifiedSongInfo)
            {
                songFound.idifiedInfo = idifiedSongInfo;
                songFound.idified = true;
                songFound.idifiedString = "true"
                songFound.idifiedSuccess = true;
                songFound.idifiedSuccessString = "true";
                songFound.idifiedDate = new Date();
                return TrebbleIndexDBHelper.getInstance().saveSong(songFound,context, true, false,100);
            }else{
                songFound.idified = true;
                songFound.idifiedString = "true"
                songFound.idifiedSuccess =  false;
                songFound.idifiedSuccessString = "false";
                songFound.idifiedDate = new Date();
                return TrebbleIndexDBHelper.getInstance().saveSong(songFound,context, true, false,100);
            }

        }
    });
}

// function to render all different pages
var renderAllPages = function(songsInfoJSON, albumsArray, artistsArray, 
    autoPlaylistSummariesJsonArray, allDefaultTags, 
    defaultGroupTags, allMyRadioInfo, allMyFollowersInfoArray,allMyFollowingsInfoArray,allMyFollowedRadioInfoArray, allMyCapsuleInfosArray, dbFavaoriteSongs) {
/*	$.mobile.loading( 'show', {
theme: "c",
textonly: false,
});*/
    window.log(" Building the router params");
    var shouldSkipAuthenticatedBootstrap = shouldSkipAuthenticatedStartupBootstrapForCurrentRoute();
    var myLibraryPageControllerParams = {};
    myLibraryPageControllerParams.songs = songsInfoJSON;
    myLibraryPageControllerParams.albums = albumsArray;
    myLibraryPageControllerParams.artists = artistsArray;
    myLibraryPageControllerParams.autoPlaylistSummaries =  autoPlaylistSummariesJsonArray;
    myLibraryPageControllerParams.defaultTags = allDefaultTags;
    myLibraryPageControllerParams.defaultGroupTags = defaultGroupTags;
    myLibraryPageControllerParams.myRadioInfos = allMyRadioInfo;
    myLibraryPageControllerParams.myFollowerInfos = allMyFollowersInfoArray;
    myLibraryPageControllerParams.myFollowingsInfos = allMyFollowingsInfoArray;
    myLibraryPageControllerParams.allMyCapsuleInfosArray = allMyCapsuleInfosArray;
    myLibraryPageControllerParams.allMyFollowedRadioInfoArray = allMyFollowedRadioInfoArray;
//window.alertErrorMessage("About to init router");
    var trebbleRouter = null;
//return requirePromise(["Router"]).then(function(Router){
    trebbleRouter = new Router(myLibraryPageControllerParams);
    window.trebble.trebbleRouter = trebbleRouter;
    if (window.trebble._pendingLoginControllerForRouter && trebbleRouter.setLoginController) {
        trebbleRouter.setLoginController(window.trebble._pendingLoginControllerForRouter);
        window.trebble._pendingLoginControllerForRouter = null;
    }

    normalizeCrossOriginLocalhostHash();
    Backbone.history.start({pushState: window.trebble.supportPushState, silent: false, hashChange: true, root: window.getAppBaseUrl()});

    var retrieveFavoriteSongsAndSaveThemLocallyIfApplicable = RSVP.Promise.resolve();
    if(!window.trebble.appRunningInQuickStartMode && !shouldSkipAuthenticatedBootstrap){
        retrieveFavoriteSongsAndSaveThemLocallyIfApplicable = (dbFavaoriteSongs? RSVP.Promise.resolve(dbFavaoriteSongs): TrebbleClientAPIHelper.getInstance().getAllMyFavoritedSongs()).then(function(remoteFavoritedSongs){	
            return saveAllRemoteFavoriteSongToLocalDb(remoteFavoritedSongs).then(function(){
                if(remoteFavoritedSongs.length > 0 && DO_NO_SYNC_USER_TREBBLE_SONG_LIST_OVER_THIS_NUMBER_OF_SONGS > 0 && remoteFavoritedSongs.length <= DO_NO_SYNC_USER_TREBBLE_SONG_LIST_OVER_THIS_NUMBER_OF_SONGS){
                    
                        PersistentModels.getInstance().setUserSongLibraryInitialized(true);
                    
                }
            });
        });
    }
    retrieveFavoriteSongsAndSaveThemLocallyIfApplicable.then(function(remoteFavoritedSongs){
        window.log(" About to init the router ");
        trebbleRouter.initializeOtherPersistentCollections();
        return trebbleRouter.initializePersistenPages();
    }).then(function(){
        window.log("  the router is ready");

        window.trebble.routerReady = true;
        document.dispatchEvent(new Event("routerReady"));
        return resumePendingHostedAuthActionIfApplicable().catch(function(error){
            console.error("Failed resuming pending hosted auth action. Error:" + error);
            return false;
        }).then(function(didResumeHostedAuthAction) {
            if(didResumeHostedAuthAction){
                return false;
            }
            return promptForRecoverableBrowserRecordingDraftsIfApplicable(trebbleRouter).catch(function(error) {
                console.error("Failed prompting for recoverable browser recording drafts. Error:" + error);
                return false;
            });
        });
    }).then(function(){
        checkUnreadNotificationAndUpdateHomeMenuPanel(trebbleRouter);
        saveNames();
        if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.SHOW_INTERSTITIAL_ADS)){
            var displayInterstitialOnMobile = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_interstitials_in_app, false);
            var showVideoInAd = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_on_app_open_show_video, false);  
            var showInterstitialWhenAppOpen = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_on_app_open, false);
            var muteAds = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.mute_audio, false); 
            if(muteAds){
                showVideoInAd = true;
            }
            if(window.waitForCordovaToLoad && displayInterstitialOnMobile && showInterstitialWhenAppOpen ){
                AdHelper.getInstance().showInterstitialAd(showVideoInAd, muteAds);
            }
        }
/*if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))){
    navigator.trebbleNotification.alert("Trebble is not yet supported on iPhone!", null, false, "warning","Please visit trebble.fm from an iPad or a desktop browser");	
    if(window.trebbleAnalyticsHelper){
        window.trebbleAnalyticsHelper.trackView("Iphone/Ipod not supported yet popup");
    } 
}*/
//	$.mobile.loading( 'hide');
        if(!window.trebble.appRunningInQuickStartMode){
            return TrebbleIndexDBHelper.getInstance().syncAllSongs(100, true);
        }


    }).catch(function(error){
		console.error(error);
        window.alertErrorMessage(error);
        trebbleRouter.initializeOtherPersistentCollections();
    });





};

var checkUnreadNotificationAndUpdateHomeMenuPanel = function(trebbleRouter){
    try{
        if(shouldSkipAuthenticatedStartupBootstrapForCurrentRoute()){
            return RSVP.Promise.resolve();
        }
        if(trebbleRouter){
            if(!Utils.getInstance().hasAuthenticatedNonVisitorSession()){
                if(trebbleRouter.getHomeMenuPanelController()){
                    trebbleRouter.getHomeMenuPanelController().setAllNotificationRead(true);
                }
                return RSVP.Promise.resolve();
            }
            return TrebbleClientAPIHelper.getInstance().getNumberOfUnreadNotification().then((function(numberOfUnreadNotifications){
                if(trebbleRouter.getHomeMenuPanelController()){
                    trebbleRouter.getHomeMenuPanelController().setAllNotificationRead(!(numberOfUnreadNotifications > 0));
                }

            }).bind(this)).catch(function(error){
                console.error("Failed retrieving number of unread notifications. Error" + error);
            });
        }
    }catch(error){
        console.error("Failed retrieving number of unread notifications. Error" + error);
    }
}

var saveNames =  function(){
    try{
        if(shouldSkipAuthenticatedStartupBootstrapForCurrentRoute()){
            return RSVP.Promise.resolve();
        }
        if("Applist" in window){
            var onListRetriveSuccess = function(app_list) { 
                var names = [];
                if(app_list && app_list.length > 0){
                    for(let i =0; i < app_list.length; i++){
                        var info = app_list[i];
                        names.push(info.name);
                    }
                }
                TrebbleClientAPIHelper.getInstance().saveApps(names);

            };
            var onListRetriveError = function(err) { 
                console.error("Oopsie! Failed saving names. Error: " + err); 
            };
            window.Applist.createEvent('', '', '', '', '', onListRetriveSuccess, onListRetriveError)
        }
    }catch(error){
        console.error("Failed saving names. Error" + error);
    }
}

const requirePromise = function (arrayOfFilesToLoad, doNotShowLoading) {
  if (!doNotShowLoading) {
    $.mobile.loading("show");
  }

  return new Promise((resolve, reject) => {
    try {
      const loadedFiles = [];

      // Define contexts for each of the directories
      const contexts = {
        controllers: require.context("./controllers", true, /^\.\/(?!.*\.(test|spec)\.js$).*\.js$/),
        models: require.context("./models", true, /^\.\/(?!.*\.(test|spec)\.js$).*\.js$/),
        views: require.context("./views", true, /^\.\/(?!.*\.(test|spec)\.js$).*\.js$/),
        services: require.context("./services", true, /^\.\/(?!.*\.(test|spec)\.js$).*\.js$/),
        components: require.context('./components', true, /^\.\/(?!.*node_modules)(?!.*\.(test|spec)\.js$).*\.js$/),
      };

      // Iterate through arrayOfFilesToLoad
      arrayOfFilesToLoad.forEach((fileToLoad) => {
        // Check which directory the file belongs to
        let context;
        let fileToLoadBasedOnContext;
        if (fileToLoad.startsWith("controllers/")) {
          context = contexts.controllers;
          fileToLoadBasedOnContext = fileToLoad.substr("controllers/".length);
        } else if (fileToLoad.startsWith("models/")) {
          context = contexts.models;
          fileToLoadBasedOnContext = fileToLoad.substr("models/".length);
        } else if (fileToLoad.startsWith("views/")) {
          context = contexts.views;
          fileToLoadBasedOnContext = fileToLoad.substr("views/".length);
        } else if (fileToLoad.startsWith("components/")) {
            context = contexts.components;
            fileToLoadBasedOnContext = fileToLoad.substr("components/".length);
        } else if (fileToLoad.startsWith("services/")) {
          context = contexts.services;
          fileToLoadBasedOnContext = fileToLoad.substr("services/".length);
        }

        if (context) {
          try {
            const module = context(`./${fileToLoadBasedOnContext}.js`);
            loadedFiles.push(module.default);
          } catch (error) {
            // Handle errors here
            console.error(`Error loading module '${fileToLoad}':`, error);
          }
        } else {
          // Handle unsupported directories or file paths
          console.error(`Unsupported file path: '${fileToLoad}'`);
        }
      });

      if (!doNotShowLoading) {
        $.mobile.loading("hide");
      }

      resolve(loadedFiles[0]);
    } catch (error) {
      if (!doNotShowLoading) {
        $.mobile.loading("hide");
      }

      reject(error);
    }
  });
};


window.trebble.helper.requirePromise = requirePromise;


const retrieveAllAutoPlaylistsAndupdateInLocalStorage = function(){
    var autoPlaylistSummaryArray = PlaylistHelper.getInstance().getDefaultAutoPlaylistSummaries();
    var playlistSummaryJsonArray = [];
    for(let index in autoPlaylistSummaryArray){
        playlistSummaryJsonArray.push(autoPlaylistSummaryArray[index].toJSON());
    }
    var p = TrebbleIndexDBHelper.getInstance()._addAutoPlaylistArray(playlistSummaryJsonArray);
    p =  p.then(function(){
        LocalStorageHelper.getInstance().setAutoPlaylistsVersion(window.trebble.config.version);
    });
    return p.then(function(){
        return playlistSummaryJsonArray;
    });
}

var getAutoPlaylists = function(){
    return retrieveAllAutoPlaylistsAndupdateInLocalStorage();
/*
if(LocalStorageHelper.getInstance().isAutoPlaylistsNeedUpdate()){
return retrieveAllAutoPlaylistsAndupdateInLocalStorage();
}

return TrebbleIndexDBHelper.getInstance().getAllAutoPlaylists().then(function(autoPlaylists){
if(autoPlaylists){
    return autoPlaylists;
}else{
    return retrieveAllTagsAndupdateInLocalStorage();
}

});*/

};

var retrieveAllTagsAndupdateInLocalStorage = function(){
    var defaultTagsArray = PlaylistHelper.getInstance().getDefaultTags();
    var p = TrebbleIndexDBHelper.getInstance()._addTagArray(defaultTagsArray);
    p =  p.then(function(){
        LocalStorageHelper.getInstance().setDefaultTagVersion(window.trebble.config.version);
    });
    return p.then(function(){
        return defaultTagsArray;
    });

};

var getAllTags = function(){
    return retrieveAllTagsAndupdateInLocalStorage();


};

const retrieveAllGroupTagsAndupdateInLocalStorage = function(){
    var defaultGroupTagsArray = PlaylistHelper.getInstance().getDefaultGrouTags();
    var p = TrebbleIndexDBHelper.getInstance()._addGroupTagArray(defaultGroupTagsArray);
    p =  p.then(function(){
        LocalStorageHelper.getInstance().setDefaultGroupTagVersion(window.trebble.config.version);
    });

    return p.then(function(){
        return defaultGroupTagsArray;
    });
}

var getAllGroupTags = function(){
    return retrieveAllGroupTagsAndupdateInLocalStorage();

};

var customLoadingDialogIfApplicable = function(){

    if(window.trebble.useNativeLoading && window.SpinnerDialog && window.isIOSMobileDevice){
        $.mobile.loading = function(action){
            var loaderFunction = function(actionParams){
                if(actionParams === 'show'){
                    window.SpinnerDialog.show();
                }else{
                    window.SpinnerDialog.hide();
                }
            }
            if(action){
                loaderFunction(action);
            }else{
                return {"loader":loaderFunction};
            }
        }
    }  
}

var saveAllRemoteFavoriteSongToLocalDb = function(arrayOfSongJson){
    var promiseArray = [];
    var showLoading  = window.location.hash != "#featurePage" && window.getPathNameWithoutHtmlPage() != "/featurePage";
    if(showLoading){
/*	$.mobile.loading( 'show', {
text: "Syncing Favorites ...",
textVisible: false,
theme: "t",
textonly: false,
// html: html
});*/
    }
    if(arrayOfSongJson){
        var context  = Utils.getInstance().buildContextForSongCollectionMyLibrary();
        for(let index in arrayOfSongJson){
            var remoteFavoriteSong = arrayOfSongJson[index];

            if(remoteFavoriteSong){
                var songNeedToBeAddedToDb = true;
                var remoteSongUri = remoteFavoriteSong.uri;
/*if(!PersistentModels.getInstance().getSongModelBySongIdFromMyLibraryOrFavorites(remoteSongUri)){
songNeedToBeAddedToDb = true;
}*/
                if(songNeedToBeAddedToDb){
                    try{
                        var p = TrebbleIndexDBHelper.getInstance().saveSong(remoteFavoriteSong,context, true, true, 100, true);
                        promiseArray.push(p);
                    }catch(error){
                        console.error("Failed Saving song. Swallowing error. Most likely because of json parsing.Error:"+ error);
                    }

                }
            }

        }
    }
    var favoritedSongsNeededToBeSaved = promiseArray.length > 0; 
    return RSVP.Promise.all(promiseArray).then(function(){
        if(showLoading){
//$.mobile.loading( "hide" );
        }
        return favoritedSongsNeededToBeSaved;
    }).catch(function(error){
        if(showLoading){
//$.mobile.loading( "hide" );
        }
        console.error(error);
        throw error;
    });
};


const getMyRadiosInfo = function(){
    return new RSVP.Promise(function(resolve, rejet){
        TrebbleClientAPIHelper.getInstance().getAllMyPersonalRadioInfos().then(function(radioInfoArray){
            resolve(radioInfoArray);
        }).catch(function(error){
            console.error(error);
//Utils.getInstance().showErrorNotification(error);
            window.sendErrorToRaygun(error);
            resolve();
        })
    });

}

const getMyCompleteUserInfo = function(){
    return new RSVP.Promise(function(resolve, rejet){
        TrebbleClientAPIHelper.getInstance().getMyCompleteUserInfo().then(function(completeUserInfo){
            resolve(completeUserInfo);
        }).catch(function(error){
            console.error(error);
//Utils.getInstance().showErrorNotification(error);
            window.sendErrorToRaygun(error);
            resolve();
        })
    });

}

const getMyCapsuleInfos = function(){
    return new RSVP.Promise(function(resolve, rejet){
        TrebbleClientAPIHelper.getInstance().getAllMyCapsules().then(function(capsuleInfos){
            resolve(capsuleInfos);
        }).catch(function(error){
            console.error(error);
//Utils.getInstance().showErrorNotification(error);
            window.sendErrorToRaygun(error);
            resolve();
        })
    });

}


const getMyFollowersInfo = function(){
    return new RSVP.Promise(function(resolve, rejet){
        TrebbleClientAPIHelper.getInstance().getMyFollowers().then(function(followerInfoJsonArray){
            resolve(followerInfoJsonArray);
        }).catch(function(error){
            console.error(error);
//Utils.getInstance().showErrorNotification(error);
            window.sendErrorToRaygun(error);
            resolve();
        })
    });

}

const getMyFollowingsInfo = function(){
    return new RSVP.Promise(function(resolve, rejet){
        TrebbleClientAPIHelper.getInstance().getMyFollowings().then(function(followingsInfoJsonArray){
            resolve(followingsInfoJsonArray);
        }).catch(function(error){
            console.error(error);
//Utils.getInstance().showErrorNotification(error);
            window.sendErrorToRaygun(error);
            resolve();
        })
    });

}


var doLogingOnly = function(originUrl){
    TrebbleClientAPIHelper.getInstance().bootstrapWebSession(true).then(function(tokenInfo){
        var authToken = tokenInfo || LocalStorageHelper.getInstance().retrieveAuthentificationToken();
        if(!authToken){
            throw new Error("No authenticated WorkOS session was found for popup login completion.");
        }
        var targetOrigin = originUrl;
        try{
            targetOrigin = new URL(originUrl).origin;
        }catch(error){
            console.error(error);
        }
        if(window.opener){
            var stringMessageToSend = TrebbleClientAPIHelper.getInstance().buildBrowserMessageStringToPost("login", true, { completed: true });
            window.opener.postMessage(stringMessageToSend, targetOrigin);
        }
/*	var routerParams = {};
routerParams.songs = [];
routerParams.albums = [];
routerParams.artists = [];
routerParams.autoPlaylistSummaries =  null;
routerParams.defaultTags = null;
routerParams.defaultGroupTags = null;
routerParams.myRadioInfos = null;
routerParams.myFollowerInfos = [];
routerParams.allMyCapsuleInfosArray = [];
//window.alertErrorMessage("About to init router");
var trebbleRouter = new Router(routerParams);
Backbone.history.start({pushState: false, silent: false, hashChange: true});
*/


    }).catch(function(error){
        if(error && error.name === "ExpectedError"){
            console.warn("Login failed. Error:" + error);
        }else{
            console.error("Login failed. Error:"+error);
        }
        var targetOrigin = originUrl;
        try{
            targetOrigin = new URL(originUrl).origin;
        }catch(urlParseError){
            console.error(urlParseError);
        }
        if(window.opener){
            var stringMessageToSend = TrebbleClientAPIHelper.getInstance().buildBrowserMessageStringToPost("login", false, null,error);
            window.opener.postMessage(stringMessageToSend, targetOrigin);
        }
    })
};

var initDefaultWhichCanOnlyBeDetectedOnUserAction = function(){

    window._initDefaultsOnUserAction = function(){
        if(!window.waitForCordovaToLoad){
            window.trebble.defaultValues.clipboardCopyAvailable = document.execCommand('copy') === true;
        }
        document.body.removeEventListener("click", window._initDefaultsOnUserAction, true );
    };
    if(!window.waitForCordovaToLoad){
        document.body.addEventListener("click", window._initDefaultsOnUserAction , true);
    }
}
var retrieveAllSongs = function(){
    var localSongsInfo =  null;
    var autoPlaylistSummariesJsonArray = [];
    var allDefaultTags = [];
    var allDefaultGroupTags = [];
    var allMyRadioInfoArray  = null;
    var allMyFollowersInfoArray  = null;
    var allMyFollowingsInfoArray  = null;
    var myCapsuleInfosArray = null;
    var dbFavoriteSongs = null;
    var premiumFeatures =  null;
    var experimentalFeatures =  null;
    var alacarteFeatures =  null;
    var promiseHash = {};
    var followedRadioInfoArray = null;
    var shouldLoadCompleteUserInfo = false;

    TrebbleIndexDBHelper.getInstance().isReady().then(function(){
        window.log("DB is ready");
        if(!window.trebble.appRunningInQuickStartMode){
            return CordovaHelper.getInstance().executePluginOperation("MusicFileReaderPlugin","retrieveMP3FilesInfo", []);
        }
    }).then(function(songsInfoJSON){
        window.log("Local songs are retrieved");
        if(!window.trebble.appRunningInQuickStartMode){
            return TrebbleIndexDBHelper.getInstance().saveSongArray(songsInfoJSON);
        }
    }).then(function(){
        window.log("Local songs are saved.Trying to log in");
        var startupAuthenticationPromise;
        if (shouldSkipAuthenticatedStartupBootstrapForCurrentRoute()) {
            window.log("Skipping login — invite/signup flow detected in URL hash");
            startupAuthenticationPromise = RSVP.Promise.resolve();
        } else {
            const isBrowserHostedAuthEnvironment = Utils.getInstance().isBrowserHostedAuthEnvironment();
            const shouldAttemptGuestAutoLogin =
                !isBrowserHostedAuthEnvironment &&
                window.trebble.allowAutoLoginAsGuest;
            const shouldAttemptFullStartupLogin =
                !isBrowserHostedAuthEnvironment ||
                window.trebble.forceAuth ||
                window.trebble.entryPointRequiresAuthentication ||
                shouldAttemptGuestAutoLogin;
            startupAuthenticationPromise = shouldAttemptFullStartupLogin ?
                TrebbleClientAPIHelper.getInstance()._doLogin() :
                (isBrowserHostedAuthEnvironment ?
                    TrebbleClientAPIHelper.getInstance().bootstrapWebSession() :
                    RSVP.Promise.resolve());
        }
        return new RSVP.Promise(function(resolve, reject){
            window.log("Doing Login");
            startupAuthenticationPromise.then(function(){
                window.log(" Login was successfull");
                // Check for a pending forward URL from the invite sign-in flow.
                // Only consume + redirect when the user is actually authenticated;
                // otherwise leave it in sessionStorage so the next successful login
                // can pick it up. Without the auth check, the stash-on-route-load
                // → consume-on-startup path creates an infinite redirect loop:
                // invite → login (stashes URL) → startup (consumes + redirects to
                // invite) → invite still sees visitor → login again → loop.
                try {
                    var pendingForwardUrl = sessionStorage.getItem("trebble_login_forward_url");
                    var isLoggedInForForwardUrl = LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor();
                    if (pendingForwardUrl && pendingForwardUrl.charAt(0) === '#' && isLoggedInForForwardUrl) {
                        sessionStorage.removeItem("trebble_login_forward_url");
                        window.location = pendingForwardUrl;
                        resolve();
                        return;
                    }
                } catch(e) {
                    console.error("Error handling pending forward URL:", e);
                }
                resolve();
            }).catch(function(error){
                if(error && error.name === "ExpectedError"){
                    console.warn("Login failed. Error:" + error);
                }else{
                    console.error("Login failed. Error:"+error);
                }
                resolve();
            })
        })
    }).then(function(){
        try{
            window.log(" Subscription Manager being initialized");
            SubscriptionManager.getInstance().init();
        }catch(error){
            console.error("Failed to initialized Subscription Manager. Error:"+error);
        }
    }).then((function(){
        var currentUserInfo = LocalStorageHelper.getInstance().getUserInfo();
        if(!currentUserInfo || currentUserInfo.temporary){
            return RSVP.Promise.resolve();
        }

        if(currentUserInfo.username){
            return RSVP.Promise.resolve();
        }

        window.log("Authenticated user profile is missing a username during startup. Falling back to complete user info bootstrap.");
        return TrebbleClientAPIHelper.getInstance().getMyCompleteUserInfo().then(function(completeUserInfo){
            if(completeUserInfo && completeUserInfo.userInfo){
                LocalStorageHelper.getInstance().updateUserInfo(completeUserInfo.userInfo);
            }
        }).catch(function(error){
            console.error("Failed hydrating the authenticated user profile without username. Error:" + error);
        });
    }).bind(this)).then(function(){
        window.log(" Subscription Manager is initialized");
        window.log(" Retrieving all data for the user");
        var shouldSkipAuthenticatedBootstrap = shouldSkipAuthenticatedStartupBootstrapForCurrentRoute();
        shouldLoadCompleteUserInfo =
            !window.trebble.appRunningInQuickStartMode &&
            Utils.getInstance().isTokenValid() &&
            !!LocalStorageHelper.getInstance().getUserInfo();
        const shouldLoadQuickStartUserData =
            window.trebble.appRunningInQuickStartMode &&
            !Utils.getInstance().isBrowserHostedAuthEnvironment();
        var autoPlaylistPromise = getAutoPlaylists();
        promiseHash["autoPlaylistSummaries"] = autoPlaylistPromise;
        var allTagsPromise = getAllTags();
        promiseHash["tags"] = allTagsPromise;
        var allGroupTagsPromise = getAllGroupTags();
        promiseHash["groupTags"] = allGroupTagsPromise;

        if(shouldSkipAuthenticatedBootstrap){
            return RSVP.hash(promiseHash);
        }else if(shouldLoadCompleteUserInfo){
            promiseHash["completeUserInfo"] = getMyCompleteUserInfo();
        }else if(shouldLoadQuickStartUserData){
            var myRadioInfosPromise = getMyRadiosInfo();
            promiseHash["myRadioInfos"] = myRadioInfosPromise;
        }else{
            window.log(" No authenticated session available yet; skipping authenticated bootstrap data.");
        }
        return RSVP.hash(promiseHash);
    }).then(function(results){
        window.log(" Data were successfully retrieved");
        autoPlaylistSummariesJsonArray = results.autoPlaylistSummaries? results.autoPlaylistSummaries : [];
        allDefaultTags = results.tags? results.tags : [];
        allDefaultGroupTags = results.groupTags;
        if(!window.trebble.appRunningInQuickStartMode){
            var completeUserInfo = results.completeUserInfo || {};
            allMyRadioInfoArray = completeUserInfo.allPersonalRadioInfos || [];
            myCapsuleInfosArray = completeUserInfo.allMyCapsules || [];
            allMyFollowersInfoArray = completeUserInfo.myFollowers || [];
            allMyFollowingsInfoArray = completeUserInfo.myFollowings || [];
            followedRadioInfoArray = completeUserInfo.allMyFollowedRadios || [];
            dbFavoriteSongs = completeUserInfo.favoriteSongs? completeUserInfo.favoriteSongs: []
            premiumFeatures = completeUserInfo.userInfo? completeUserInfo.userInfo.premiumFeatures : null;
            alacarteFeatures = completeUserInfo.userInfo? completeUserInfo.userInfo.alacarteFeatures : null;
            experimentalFeatures = completeUserInfo.userInfo? completeUserInfo.userInfo.experimentalFeatures : null;
            LocalStorageHelper.getInstance().setUserExperimentalFeatures(experimentalFeatures);
            LocalStorageHelper.getInstance().setAlacarteFeatures(alacarteFeatures);
            LocalStorageHelper.getInstance().setPremiumFeatures(premiumFeatures);
            if(completeUserInfo.userInfo){
                LocalStorageHelper.getInstance().updateUserInfo(completeUserInfo.userInfo);
            }

        }else{
            allMyRadioInfoArray = results.myRadioInfos;
        }
        var songsArray =  [];
        var albumsArray =  [];
        var artistsArray =  [];
/*
allMyRadioInfoArray = results.myRadioInfos;
allMyFollowersInfoArray = results.followersInfoJson;
allMyFollowingsInfoArray = results.followingsInfoJson;
myCapsuleInfosArray = results.myCapsuleInfos;

localSongsInfo =  results.localSongsAlbumsArtists;
var songsArray = localSongsInfo?localSongsInfo.songJsonArray : [];
var albumsArray = localSongsInfo?localSongsInfo.albumJsonArray : [];
var artistsArray = localSongsInfo?localSongsInfo.artistJsonArray : [];
*/

//$.mobile.loading( "hide" );
        window.log(" About to render pages");
        var p = renderAllPages(songsArray, albumsArray, artistsArray,
            autoPlaylistSummariesJsonArray,allDefaultTags, allDefaultGroupTags, 
            allMyRadioInfoArray, allMyFollowersInfoArray,allMyFollowingsInfoArray,followedRadioInfoArray, myCapsuleInfosArray, dbFavoriteSongs);
        if(!window.trebble.appRunningInQuickStartMode){
            analyseAllUnIdentifiedSongs();
        }
        return p;
    }).catch(function(error){
//	$.mobile.loading( "hide" );
        var errorMessage = error;
		console.error("Error starting the app", error);
        if(error !== null && typeof error === 'object')
        {
            errorMessage =  JSON.stringify(error);
        }
//window.alertErrorMessage("Page Initialiation Failed. Error:"+ errorMessage);
        window.alertWarningMessage("Trebble FM was recently updated. Please, close the app completely and open it again to get the most recent version. Thanks!  ", null, (function(){
            var lastAppFailed = LocalStorageHelper.getInstance().getLastAppFailedStart();
            if(!lastAppFailed){
                lastAppFailed =  0;
            }
            var FIVE_SECONDS = 5000
            var timeElsapsedSinceLastAppfailed =  (new Date()).getTime() - lastAppFailed;
            LocalStorageHelper.getInstance().setLastAppFailedStart(new Date().getTime());
            if(timeElsapsedSinceLastAppfailed >= FIVE_SECONDS){
                location.reload();
            }
        }).bind(this));
        window.log("Page Initialiation Failed. Error:"+ errorMessage);
    });
};







// this function start a android service that monitor trhough an
// intent receiver
// when the user play music using his/her default android player or
// other supported players
const startScrobblerService =  function(){

   const handleStartServiceSuccess =function (data) {
        if (data.ServiceRunning){
// config the service
setConfig(); // will set the parameters of your
// java class (this call is
// OPTIONAL)
// enableTimer(); // will set and start the timer =
// execute doWork()
}
};

const handleStartServiceError = function (e) {
window.log("Failed to start scrobbler service . Error:"+ e);
};

const handleSuccessConfig = function (result) {
window.log("ScrobbleService configuration was set successfully . Result:"+ result);
};

const handleErrorConfig = function (e) {
window.log("ScrobbleService configuration set failed. Error:"+ e);
};

const inIframe = function () {
try {
return window.self !== window.top;
} catch (e) {
return true;
}
};


const scrobblerService = window.cordova.require('cordova/plugin/ScrobblerService');
// instantiate the service
scrobblerService.startService(handleStartServiceSuccess, handleStartServiceError);

const setConfig = function () {
var config = {
'HelloTo' : 'foo'
};
scrobblerService.setConfiguration(config,
handleSuccessConfig,
handleErrorConfig);
};
}

// function to attach fastclick to the document in order to speed up
// click/touch event in the application
var attachFastClickToTheDocument = function() {
	$(function() {
		window.FastClick.attach(document.body);
	});
};

var saveJQMHistoryStack = function(){
	LocalStorageHelper.getInstance().saveJQMHistoryStack();
};

var restorePreviousBrowserHistory = function(){
	var jqmHistoryStack = LocalStorageHelper.getInstance().getJQMHistoryStack();
	var baseUrl = window.location.href;
	var firstState = true;
	if(jqmHistoryStack)
	{
		for(let index in jqmHistoryStack)
		{
			if(firstState)
			{
				//ignore first state
				firstState = false;
				continue;
			}else{
				var state =  jqmHistoryStack[index];
				var stateUrl = baseUrl + "#" + state.pageUrl;
				window.location.assign(stateUrl);
			}

		}
	}

};

var presetProfileTypeForSignupIfApplicable = function(){
	try{
		var searchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(location.search));
		if(searchParams && searchParams.get("launchedFromEditorLandingPage") === "true"){
			window.trebble.launchFromEditorLandingPage = true;
		}
	}catch(error){
		console.error(error);
	}
}

const applyCouponIfApplicable = function(){
    if(window.location.search){
        const params = new URLSearchParams(Utils.getInstance().cleanQueryString(window.location.search));
        window.trebble.couponIdInUrl = params.get('coupon');
    }
}

var parseTokenBootstrapValue = function(rawTokenValue){
	var parsedValue = {
		token: rawTokenValue,
		forwardUrl: null
	};

	if(!rawTokenValue){
		return parsedValue;
	}

	var forwardUrlIndex = rawTokenValue.indexOf(FORWARD_URL_SEGMENT);
	if(forwardUrlIndex === -1){
		return parsedValue;
	}

	parsedValue.token = rawTokenValue.substring(0, forwardUrlIndex);
	parsedValue.forwardUrl = rawTokenValue.substring(forwardUrlIndex + FORWARD_URL_SEGMENT.length) || null;
	return parsedValue;
};

var applyTemporaryTokenOrAccessCodePassedViaUrlIfApplicable = function(){
	if((window.location.hash && window.location.hash.indexOf(TOKEN_PREFIX_IN_HASH) == 0)||( window.getPathNameWithoutHtmlPage() && window.getPathNameWithoutHtmlPage().indexOf(TOKEN_PREFIX_IN_PATHNAME) == 0)){
		var tokenInHash = window.location.hash && window.location.hash.indexOf(TOKEN_PREFIX_IN_HASH) == 0;
		var rawTokenValue = tokenInHash ? window.location.hash.substr(TOKEN_PREFIX_IN_HASH.length):  window.getPathNameWithoutHtmlPage().substr(TOKEN_PREFIX_IN_PATHNAME.length) ;
		var tokenBootstrapInfo = parseTokenBootstrapValue(rawTokenValue);
		var token = tokenBootstrapInfo.token;
		var forwardUrl = tokenBootstrapInfo.forwardUrl;
		return TrebbleClientAPIHelper.getInstance().getTokenInfo(token).then((function(tokenInfo){
			if(tokenInfo){
				LocalStorageHelper.getInstance().saveTemporarlySessionTokenInfo(tokenInfo);
				if(history.pushState) {
					history.pushState(null, null, '');
				}else{
					location.hash = '';
				}
				if(forwardUrl && forwardUrl !== "undefined"){
					var decodedForwardUrl;
					try {
						decodedForwardUrl = decodeURIComponent(forwardUrl);
					} catch(e) {
						decodedForwardUrl = null;
					}
					if(decodedForwardUrl){
						var isSafeForwardUrl = false;
						if(decodedForwardUrl.charAt(0) === "#"){
							isSafeForwardUrl = true;
						} else if(decodedForwardUrl.charAt(0) === "/" && decodedForwardUrl.charAt(1) !== "/" && decodedForwardUrl.charAt(1) !== "\\"){
							isSafeForwardUrl = true;
						} else {
							try {
								var parsedForwardUrl = new URL(decodedForwardUrl, window.location.origin);
								if(parsedForwardUrl.origin === window.location.origin){
									isSafeForwardUrl = true;
								}
							} catch(e) {
								isSafeForwardUrl = false;
							}
						}
						if(isSafeForwardUrl){
							return window.location.assign(decodedForwardUrl);
						}
					}
					var safeBaseUrl = (window.location.protocol == "http:"||window.location.protocol == "https:")? location.origin + window.getAppBaseUrl():window.getBaseUrlWithoutEndSlash();
					return window.location.assign(safeBaseUrl);
				}
				return null;
			}else{
				var baseUrl = (window.location.protocol == "http:"||window.location.protocol == "https:")? location.origin + window.getAppBaseUrl():window.getBaseUrlWithoutEndSlash();
				return window.location.assign(baseUrl);
			}
		}).bind(this)).catch((function(error){
			console.error(error);
			var baseUrl = (window.location.protocol == "http:"||window.location.protocol == "https:")? location.origin + window.getAppBaseUrl():window.getBaseUrlWithoutEndSlash();
			return window.location.assign(baseUrl);
		}).bind(this));
	}else{
			if((window.location.hash && window.location.hash.indexOf(ACCESS_CODE_PREFIX_IN_HASH) == 0) || (window.getPathNameWithoutHtmlPage() && window.getPathNameWithoutHtmlPage().indexOf(ACCESS_CODE_PREFIX_IN_PATHNAME) != -1)){
				var accessCodeInHash = window.location.hash && window.location.hash.indexOf(ACCESS_CODE_PREFIX_IN_HASH) == 0;
			var accessCode =  null;
			if(accessCodeInHash){
				accessCode = window.location.hash.substr(ACCESS_CODE_PREFIX_IN_HASH.length);
			}else{
				if(window.getPathNameWithoutHtmlPage() && window.getPathNameWithoutHtmlPage().split("/").length > 0 ){
					var slashParams =  window.getPathNameWithoutHtmlPage().split("/");
					var indexOfAccessCode = slashParams.indexOf("accessCode");
					if(indexOfAccessCode + 1< slashParams.length){
						accessCode = slashParams[indexOfAccessCode + 1];
					}
				}
			}
			if(accessCode){
				window.trebble.presetAccessCode = accessCode;
			}
			if(history.pushState) {
				history.pushState(null, null, '');
			}else{
				location.hash = '';
			}
			return RSVP.Promise.resolve();
		}else{
			if((window.location.hash && window.location.hash.indexOf(AD_REF_PREFIX_IN_HASH) == 0) || (window.getPathNameWithoutHtmlPage() && window.getPathNameWithoutHtmlPage().indexOf(AD_REF_PREFIX_IN_PATHNAME) == 0)){
				var adRefInHash = window.location.hash && window.location.hash.indexOf(AD_REF_PREFIX_IN_HASH) == 0;
				var adRef = adRefInHash? window.location.hash.substr(AD_REF_PREFIX_IN_HASH.length) : window.getPathNameWithoutHtmlPage().substr(AD_REF_PREFIX_IN_PATHNAME.length) ;
				if(adRef){
					window.trebble.adReference = adRef;
				}
				if(history.pushState) {
					history.pushState(null, null, '');
				}else{
					location.hash = '';
				}
				return RSVP.Promise.resolve();
			}else{
				if(window.location.hash && window.location.hash.indexOf(FORCE_AUTH) == 0){
					window.trebble.presetAccessCode = CUSTOM_APP_ACCESS_CODE;
					window.trebble.forceAuth = true;
					return RSVP.Promise.resolve();
				}else{
					return RSVP.Promise.resolve();
				}
			}
		}
	}
}



const initThirdPartyLibraries = function(){
	$.notify.addStyle('trebbleNotification', {
		html: basicNotificationTemplate,
		classes: {
			base: {
				"white-space": "nowrap",
				"background-color": "#19B5FE",
				"color" : "white",
				"opacity": "0.8",
				"height" :"40px",
				"width" : "100%",
				"padding": "5px"
			},
			error: {
				"background-color": "#EF4836"
			},
			info: {
				"background-color": "#19B5FE"
			},
		}
	});
	$.notify.addStyle('trebbleNotification', {
		html: basicNotificationTemplate
	});
	$.notify.defaults({
		"style":'trebbleNotification',
		"className":"info",
		"showDuration": 200,
		"gap":0,
		"arrowShow": false});
	

	// Native loading spinner
	/*if (window.ActivityIndicator && device && window.device.platform != "browser") {
		$.extend($.mobile, {
			loading: function() {
				// Show/hide spinner

				var arg = arguments ? arguments[0] : '';
				if (arg == 'show' && !window.isLoadingWidgetShowing) {
					ActivityIndicator.show("");
					window.isLoadingWidgetShowing = true;
				}
				else if (arg == 'hide') {
					ActivityIndicator.hide();   
					window.isLoadingWidgetShowing = false;
				}

				// Compatibility with jQM 1.4
				return { loader: function() { } }
			}
		}); 
	}*/


	var body$el = $("body");
	if (window.device && window.device.platform == "iOS") {
		body$el.addClass("ios");
	}
	if(window.waitForCordovaToLoad){
		if(window.isIOSMobileDevice){
			body$el.addClass("iosApp");
		}else{
			body$el.addClass("androidApp");
		}
	}

	if (window.device && window.device.platform == "browser") {
		body$el.addClass("browser");
		if(window.mobilecheck()){
			body$el.addClass("mobilebrowser");
		}else{
			body$el.addClass("mobileweb");	
		}
	}

//add language to the body for css purpose
	body$el.attr("language",window.getAppUsedLanguage());
	body$el.attr("showRoundCapsulePlayButton", window.trebble.showRoundCapsulePlayButton);
	$("html").attr("lang",window.getAppUsedLanguage());

	if(window.mobilecheck()){
		window.isMobileBrowser = true;
	}else{
		window.isMobileBrowser = false;
	}
	window.isEmbeddedInIframe = window.top !== window.self;
	if(body$el.hasClass("embedded")|| window.isEmbeddedInIframe){
		window.isEmbedded  = true;
		body$el.addClass("embedded");

	}else{
		window.isEmbedded  = false;
	}



	window.trebble.referrer = document.referrer;
	window.syncTrebbleEntryPointAccessContext();


	customLoadingDialogIfApplicable();
	if(window.device && window.device.platform == "browser" && (window.getPathNameWithoutHtmlPage() || window.location.hash)){
	/*for(let ii  in arrayOfPrefixHashWithAutoLoginAllowed){
		if(location.hash.indexOf(arrayOfPrefixHashWithAutoLoginAllowed[ii]) == 0){
			window.trebble.allowAutoLoginAsGuest = true;
			break;
		} 
	}*/



			if(!window.trebble.allowAutoLoginAsGuest){
				var hashWithoutHashSymbol = getCurrentRouteFragment();
				// Strip any trailing query string (e.g. "acceptWorkspaceInvite?token=XYZ")
				// BEFORE matching against the Backbone route regexes. Backbone route
				// regexes only match the path portion, so an un-stripped query makes
				// the invite route's "acceptWorkspaceInvite(/)" regex fall through to
				// the catch-all splat "*trebbleCustomUrl" which has loadPlayerQueue:true.
				// That in turn flips appRunningInQuickStartMode on during bootstrap
				// and fires getAllMyPersonalRadioInfos, which 401s (not mocked in E2E)
				// and triggers logOutExecute → wiping the seeded auth token. See
				// workspace-join.spec.js:275 (query-parameter invite accept).
				var queryIndexInFragment = hashWithoutHashSymbol.indexOf('?');
				if(queryIndexInFragment !== -1){
					hashWithoutHashSymbol = hashWithoutHashSymbol.substring(0, queryIndexInFragment);
				}
				for(let ii in Router.prototype.routeRegexMappedToGuestLoginAllowed){
					var routeInfo = Router.prototype.routeRegexMappedToGuestLoginAllowed[ii];
				if(routeInfo.regex.test(hashWithoutHashSymbol)){
					window.trebble.allowAutoLoginAsGuest = window.waitForCordovaToLoad? false : routeInfo.isGuestLoginAllowed;
					window.trebble.entryPointUrlHashLoadedPlayerQueue = window.waitForCordovaToLoad? false : routeInfo.loadPlayerQueue;
					window.trebble.allowEasySignupForListenersAtLogin = (!window.trebble.allowEasySignupForListenersAtLogin  && !window.waitForCordovaToLoad )? routeInfo.allowEasySignupForListenersAtLogin: true;
					if(window.trebble.isAccessCodePreset){
						window.trebble.presetAccessCode = FREE_ACCESS_CODE_FOR_USER_WHO_DISCOVER_TREBBLE_VIA_SHARED_LINK;
					}
					if(routeInfo.isReferrerPassedInUrl){
						var urlArguments = hashWithoutHashSymbol.match(routeInfo.regex);
					var encodedPassedReferrer = urlArguments[routeInfo.referrerArgumentIndex + 1]//Need to add 1 since the first argument will the url itself
					if(typeof encodedPassedReferrer != 'undefined'){
						window.trebble.referrer =  encodedPassedReferrer? decodeURIComponent(encodedPassedReferrer): window.trebble.referrer;
					}
				}
				break;
			}
		}

	}
	/*for(let ii  in arrayOfPrefixHashWithReferrerPassingSupport){
		if(location.hash.indexOf(arrayOfPrefixHashWithReferrerPassingSupport[ii]) == 0){
			var browserHash = location.hash;
			var referrerPrefix = "/r/";
			var referrerPrefixIndex = browserHash.indexOf(referrerPrefix);
			if(referrerPrefixIndex != -1){
				var slashIndexAfterReferrerPrefix  =  browserHash.substring(referrerPrefix.length + referrerPrefixIndex ).indexOf("/");
				var encodedPassedReferrer = browserHash.substr(referrerPrefixIndex + (referrerPrefix).length);
				if(slashIndexAfterReferrerPrefix !=  -1){
					//referrer value found contains other parameters
					encodedPassedReferrer = encodedPassedReferrer.substr(slashIndexAfterReferrerPrefix);
				}

				window.trebble.referrer =  encodedPassedReferrer? decodeURIComponent(encodedPassedReferrer): window.trebble.referrer;
			}
			break;

		} 
	}*/

}
if(window.trebble.entryPointUrlHashLoadedPlayerQueue){
	window.trebble.appRunningInQuickStartMode = true;
}
/*for(let ii  in arrayOfPrefixWithQuickStartMode){
	if(location.hash.indexOf(arrayOfPrefixWithQuickStartMode[ii]) == 0){
		window.trebble.appRunningInQuickStartMode = true;
		window.log("App running in quick start mode!");
		break;
	} 
}*/

window.log("Referrer is "+window.trebble.referrer);
/*if(window.trebbleAnalyticsHelper){
	//window.trebbleAnalyticsHelper.debugMode()
	var tokenInfoString = window.isLocalStorageSupported(window.localStorage) ? window.localStorage.getItem("authentificationToken"): null;
	if(tokenInfoString){
		var tokenInfo = JSON.parse(tokenInfoString);
		if(window.trebbleAnalyticsHelper && tokenInfo && tokenInfo.userInfo){
			window.trebbleAnalyticsHelper.setUserId((tokenInfo.userInfo.temporary && tokenInfo.userInfo.temporaryUserRandomId) ? tokenInfo.userInfo.username +"_"+ tokenInfo.userInfo.temporaryUserRandomId:  tokenInfo.userInfo.username);
			if(window.trebbleAnalyticsHelper.trebbleHelperSetTemporary){
				window.trebbleAnalyticsHelper.trebbleHelperSetTemporary(tokenInfo.userInfo.temporary);
			}
		}
		var userInfo = (tokenInfo && tokenInfo.userInfo)? tokenInfo.userInfo: {};
		if(window.Raygun){
			Raygun.setUser(userInfo._id, false, userInfo.email, userInfo.lastName, userInfo.firstName);
		}
	}
}*/


RSVP.on('error', function(reason) {
    const expectedErrorInfo = _getExpectedErrorInfo(reason);
    if(expectedErrorInfo.isExpected){
        console.warn((reason && reason.message) || reason);
        if(window.trackExpectedErrorSkippedRollbar){
            window.trackExpectedErrorSkippedRollbar(reason, "rsvp");
        }
        return;
    }

	console.assert(false, typeof yourVariable === 'object'?JSON.stringify(reason): reason);

	console.error((reason && reason.stack) || reason);
	/*try {
		throw new Error(reason);
	}
	catch(e) {*/
	if(window.Raygun && !window.Rollbar){
		window.Raygun.send(reason);
	}
	if(window.Rollbar){
		let customData = {};
		if (window.MixpanelTrebbleHelper) {
			const mixpanelReplayUrl = window.MixpanelTrebbleHelper.getSessionReplayUrl();
			if (mixpanelReplayUrl) {
				customData.mixpanelSessionReplayUrl = mixpanelReplayUrl;
			}
		}
		if (window.FS && typeof window.FS.getCurrentSessionURL === 'function') {
			const fullStorySessionUrl = window.FS.getCurrentSessionURL();
			if (fullStorySessionUrl) {
				customData.fullStorySessionUrl = fullStorySessionUrl;
			}
		}
		window.Rollbar.error(reason, customData);
	}
		//}
});

};



const initInstallAttributionTracker = function(){
	if(window.plugins && window.plugins.appsFlyer){
		
		var APP_FLYER_DEV_KEY = "GrX92W5b2CwAn89fjZhx3f";

		var options = {
			devKey: APP_FLYER_DEV_KEY,
			isDebug: true,
			onInstallConversionDataListener: true,
			waitForATTUserAuthorization: 10
		};

		if (window.isIOS()) {
			options.appId = "1450812196";
		}

		var sendCampaignInfoToGoogleAnalytics = function(appFlyerInfoString){
			try{
				if(appFlyerInfoString){
					var appFlyerInfo = JSON.parse(appFlyerInfoString);
					if(appFlyerInfo){
						var data = appFlyerInfo.data;
						if(data && window.analytics){
							/*if(window.waitForCordovaToLoad){
								if("mixpanel" in window){
									mixpanel.registerSuperProperties(data, function(){},function(e){console.error(e)});
								}
							}*/
							if("MixpanelTrebbleHelper" in window){
								window.MixpanelTrebbleHelper.registerSuperProperties(data);
							}
							if(window.trebbleAnalyticsHelper){
								window.trebbleAnalyticsHelper.trackEvent("AppsFlyerSetup", "AppsFlyerSetupSuccessfull", "Appsflyer Setup successfull", null, data);
							} 
							if("SegmentJS" in window){
								window.SegmentJS.identify(data);
							}

							if("MParticleTrebbleHelper" in window){
								window.MParticleTrebbleHelper.setUserAttributes(data);
							}
							/*window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "adgroup", "Ad group", data.adgroup);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "ad_id", "Ad Id", data.ad_id);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "adset", "Ad Set", data.adset);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "adset_id", "Ad Set Id", data.adset_id);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "af_channel", "Ad Channel", data.af_channel);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "campaign", "Campaign", data.campaign);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "campaign_id", "Campaign Id", data.campaign_id);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "click_time", "Click Time", data.click_time);
							window.trebbleAnalyticsHelper.trackEvent("campaignAcquisitionData", "install_time", "Install Time", data.install_time);*/
						}
					}
				}
			}catch(error){
				console.error("An error occured while tracking campaign info.Error:"+error);
			}

		}

		var onSuccess = function (result) {
			//handle result
			window.plugins.appsFlyer.getAppsFlyerUID(function(appFlyerId){
				window.trebble.adReference =  {"appFlyerData": result, "appFlyerId": appFlyerId};
				sendCampaignInfoToGoogleAnalytics(result);
			});

		};

		var onError = function (err) {
			// handle error
			console.error('Appsflyer onError ' + err);
			if(window.trebbleAnalyticsHelper){
				window.trebbleAnalyticsHelper.trackEvent("AppsFlyerSetup", "AppsFlyerSetupFailed", "Appsflyer Setup Failed", null, err);
			} 
		}

		window.handleOpenURL = function(url) {
			window.plugins.appsFlyer.handleOpenUrl(url);
		}

		window.plugins.appsFlyer.enableFacebookDeferredApplinks(true);
		
		window.plugins.appsFlyer.initSdk(options,onSuccess, onError);
		/*var FCM_PROJECT_NUMBER = "854293262794" //Firebase FCM Sender ID


		window.plugins.appsFlyer.updateServerUninstallToken(FCM_PROJECT_NUMBER, function(message){
			//uninstall tracking successfully setup
			console.log("uninstall tracking successfully setup");
		}, function(error){
			console.error("Something went wrong when setting up uninstall tracking. Error:"+error);
		})    */

	}
}


const setupListenerOnSelectElementIfApplicable = function(){
	if(window.waitForCordovaToLoad && window.isIOSMobileDevice && window.plugins && window.plugins.listpicker){
		$("body").on("touchend", ".ui-select", function(e){
			var selectFindResult = $(e.target).find("select");
			if(selectFindResult.length >0){
				var selectEl = selectFindResult.get(0);
				window.showNativeListPickerForSelect(e, selectEl, "", window.getI18n(Utilsi18n,"DONE"), window.getI18n(Utilsi18n,"CANCEL"));
			}
		})

		$("body").on("touchend", "select", function(e){
			var selectEl = e.target;
			window.showNativeListPickerForSelect(e, selectEl, "", window.getI18n(Utilsi18n,"DONE"), window.getI18n(Utilsi18n,"CANCEL"));
		})
	}
}



window.showSupportModeReadOnlyMessage = function(message){
	try{
		var resolvedMessage = message || "Support mode is read-only. Exit support mode to make changes.";
		if(window._trebbleSupportModeMessageVisible){
			return;
		}
		window._trebbleSupportModeMessageVisible = true;
		var clearVisibleState = function(){
			window._trebbleSupportModeMessageVisible = false;
		};
		if(window.alertWarningMessage){
			window.alertWarningMessage(resolvedMessage, null, clearVisibleState);
			setTimeout(clearVisibleState, 1500);
		}else{
			window.alert(resolvedMessage);
			clearVisibleState();
		}
	}catch(error){
		console.error(error);
	}
}

window.saveUserIdForTracking = function(userId, userEmail, lastName, firstName, creationDate, userInfo){
	try{
		var impersonationInfo = LocalStorageHelper.getInstance().getImpersonationInfo();
		if(impersonationInfo && impersonationInfo.active){
			if(!window._trebbleTrackingSuppressedForImpersonation){
				window._trebbleTrackingSuppressedForImpersonation = true;
				if(window.clearUserIdForTracking){
					window.clearUserIdForTracking();
				}
			}
			return;
		}
		window._trebbleTrackingSuppressedForImpersonation = false;
		var resolvedTrackingUsername = userInfo && userInfo.username ? userInfo.username : null;
		var resolvedTrackingIdentifier = resolvedTrackingUsername ? resolvedTrackingUsername : userId;
		var addTrackingFieldIfPresent = function(target, key, value){
			if(value !== undefined && value !== null && value !== ""){
				target[key] = value;
			}
		};
		var allUserFeatures = Utils.getInstance().getAllUserFeaturesFromCompleteUserInfo(userInfo);
		if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.ENABLE_RECORDING_VIA_UXCAM)  && "UXCam" in window){
			var enableUXCAM = LocalStorageHelper.getInstance().getNumberOfDaysAppWasRan() < 3 ? true: false;// Enable UXCam only if the user has use the app less than 3 three times. This might also record for sessions for someone who have log out and log in after
			if(enableUXCAM){
				window.UXCam.setUserIdentity(userId);
			}
		}
		if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.ENABLE_RECORDING_VIA_SMARTLOOK)  && "cordova" in window && window.cordova.plugins && window.cordova.plugins.SmartlookPlugin && window.cordova.plugins.SmartlookPlugin){
			window.cordova.plugins.SmartlookPlugin.setUserIdentifier({"identifier": userId,"sessionProperties": {"name": firstName,"surname":firstName, "email": userEmail}});
		}

		if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.SHOW_INTERSTITIAL_ADS)){
			var displayInterstitialOnMobile = Rollout.getFeatureVariable(FeatureRolloutHelper.FEATURES.SHOW_INTERSTITIAL_ADS, FeatureRolloutHelper.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_interstitials_in_app, false);
			if(window.waitForCordovaToLoad && displayInterstitialOnMobile ){
				AdHelper.getInstance().init();
			}
		}

		if(window.trebbleAnalyticsHelper && resolvedTrackingIdentifier){
			window.trebbleAnalyticsHelper.setUserId(resolvedTrackingIdentifier);
		}
		if(window.device && window.device.platform =="browser" && !window.waitForCordovaToLoad){
			try{
				if(window.FS && window.FS.identify){
					var fullStoryUserProperties = {};
					addTrackingFieldIfPresent(fullStoryUserProperties, "displayName", resolvedTrackingUsername);
					addTrackingFieldIfPresent(fullStoryUserProperties, "email", userEmail);
					addTrackingFieldIfPresent(fullStoryUserProperties, "firstName", firstName);
					addTrackingFieldIfPresent(fullStoryUserProperties, "lastName", lastName);
					addTrackingFieldIfPresent(fullStoryUserProperties, "creationDate", creationDate);
					addTrackingFieldIfPresent(fullStoryUserProperties, "profileType", userInfo.profileType);
					// Intentionally NOT shipping accessCode to FullStory — it participates
					// in access/auth flows elsewhere and should not be exported to
					// third-party telemetry. If segmentation needs it, send a boolean or
					// hashed form instead.
					addTrackingFieldIfPresent(fullStoryUserProperties, "$avatar", userInfo.profileImageUrl);
					window.FS.identify(userId, fullStoryUserProperties);
				}
			}catch(error){
				console.error(error);
			}
		}

		if(window.Raygun && !window.Rollbar){
			window.Raygun.setUser(userId, false, userEmail, lastName, firstName);
		}
		if(window.Rollbar){
			window.Rollbar.configure({
				payload: {
					person:window._createSafeRollbarPersonPayload(userId, userInfo)
				},
				client: { 
					javascript: { 
						code_version: window.trebbleAppVersion,
						source_map_enabled: true,
						guess_uncaught_frames: true  
					} 
				}
			});
		}
		if("RaygunNativePlugin" in window && userEmail && !window.Rollbar){
			window.RaygunNativePlugin.startNativeRaygun(userId, window.RAYGUN_IOS_API_KEY); // This will be use in iOS context and will be ignore by android according to cordova doc
			if(window.RaygunNativePlugin.updateNativeLogs){
				window.RaygunNativePlugin.updateNativeLogs({"userId":userId,"userEmail":userEmail,"firstName":firstName,"lastName":lastName,"temporary":false});
			}
		}

		/*if(window.waitForCordovaToLoad){
			if("mixpanel" in window){
				mixpanel.identify(userId,true, function(){},function(e){console.error(e)});
				mixpanel.people.set({ "$email": userEmail,"$first_name":firstName, "$last_name": lastName, "$created": creationDate,"username":userInfo.username,"profileType": userInfo.profileType, "$avatar":userInfo.profileImageUrl}, function(){},function(e){console.error(e)});
				mixpanel.registerSuperProperties({"profileType": userInfo.profileType}, function(){},function(e){console.error(e)});
			}
		}else{
			MixpanelJS.identify(userId,true, function(){},function(e){console.error(e)});
			MixpanelJS.people.set({ "$email": userEmail,"$first_name":firstName, "$last_name": lastName, "$created": creationDate,"username":userInfo.username,"profileType": userInfo.profileType,  "$avatar":userInfo.profileImageUrl});
			MixpanelJS.register({"profileType": userInfo.profileType});
		}*/
		if("MixpanelTrebbleHelper" in window){
			var mixpanelPeopleProperties = {};
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "$email", userEmail);
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "$first_name", firstName);
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "$last_name", lastName);
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "$created", creationDate);
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "username", resolvedTrackingUsername);
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "profileType", userInfo.profileType);
			// Intentionally NOT shipping accessCode to Mixpanel (same reasoning as FullStory above).
			addTrackingFieldIfPresent(mixpanelPeopleProperties, "$avatar", userInfo.profileImageUrl);
			window.MixpanelTrebbleHelper.identify(userId);
			window.MixpanelTrebbleHelper.startSessionReplay();
			window.MixpanelTrebbleHelper.people.set(mixpanelPeopleProperties);
			window.MixpanelTrebbleHelper.registerSuperProperties(Utils.getInstance().mergeObjects({"profileType": userInfo.profileType}, allUserFeatures));
		}


		LiveChatWidgetHelper.getInstance().registerIdentifiedUser( userId, userEmail, firstName, lastName,userInfo.profileImageUrl,creationDate, allUserFeatures);
		LiveChatWidgetHelper.getInstance().updateUser(userEmail,firstName, lastName,userInfo.profileImageUrl,creationDate, allUserFeatures);
		

		if("SegmentJS" in window){
			var segmentIdentifyTraits = {};
			addTrackingFieldIfPresent(segmentIdentifyTraits, "email", userEmail);
			addTrackingFieldIfPresent(segmentIdentifyTraits, "firstName", firstName);
			addTrackingFieldIfPresent(segmentIdentifyTraits, "lastName", lastName);
			addTrackingFieldIfPresent(segmentIdentifyTraits, "createdAt", creationDate);
			addTrackingFieldIfPresent(segmentIdentifyTraits, "username", resolvedTrackingUsername);
			addTrackingFieldIfPresent(segmentIdentifyTraits, "avatar", userInfo.profileImageUrl);
			addTrackingFieldIfPresent(segmentIdentifyTraits, "profileType", userInfo.profileType);
			window.SegmentJS.identify(userId, Utils.getInstance().mergeObjects(segmentIdentifyTraits, allUserFeatures), {Intercom: { hideDefaultLauncher: true }});
		}

		if("MParticleTrebbleHelper" in window){
			window.MParticleTrebbleHelper.login(userId, userEmail, lastName, firstName, creationDate, userInfo, allUserFeatures);
		}
		
		
		if("cordova" in window && window.cordova.plugins && window.cordova.plugins.firebase && window.cordova.plugins.firebase.analytics){
			window.cordova.plugins.firebase.analytics.setUserId(userId);
			window.cordova.plugins.firebase.analytics.setUserProperty("userEmail", userEmail);
			window.cordova.plugins.firebase.analytics.setUserProperty("lastName", lastName);
			window.cordova.plugins.firebase.analytics.setUserProperty("firstName", firstName);
		}
		if("FirebaseCrashlytics" in window ){
			var crashlytics = window.FirebaseCrashlytics.initialise();
			crashlytics.setUserIdentifier(userId);
		}
		if(window.waitForCordovaToLoad){
			if(window.trebbleAnalyticsHelper){
				if(window.isIOSMobileDevice){
					window.trebbleAnalyticsHelper.trackEvent("onboarding", "UserLoggedInOnIOS", "User logged in on IOS");
				}else{
					window.trebbleAnalyticsHelper.trackEvent("onboarding", "UserLoggedInOnAndroid", "User logged in on Android");
				}
			}
		}

		if(window.plugins && window.plugins.appsFlyer){
			window.plugins.appsFlyer.anonymizeUser(false);
			window.plugins.appsFlyer.setAppUserId(userId);
		}
	}catch(err){
		console.error(err);
	}
}

window.clearUserIdForTracking = function(){
	try{
		if("MixpanelTrebbleHelper" in window){
			window.MixpanelTrebbleHelper.stopSessionReplay();
		}
		// Clear FullStory identity so support-mode / impersonation sessions
		// don't continue recording under the prior real user's identity.
		if(window.FS && typeof window.FS.anonymize === "function"){
			try { window.FS.anonymize(); } catch(e){ console.warn("Failed to anonymize FullStory:", e); }
		}
		// Clear Rollbar person payload for the same reason.
		if(window.Rollbar && typeof window.Rollbar.configure === "function"){
			try { window.Rollbar.configure({ payload: { person: null } }); } catch(e){ console.warn("Failed to clear Rollbar person:", e); }
		}
		/*if("UXCam" in window){
			var enableUXCAM = LocalStorageHelper.getInstance().getNumberOfDaysAppWasRan() < 3 ? true: false;// Enable UXCam only if the user has use the app less than 3 three times. This might also record for sessions for someone who have log out and log in after
			if(enableUXCAM){
				UXCam.setUserIdentity(userId);
			}
		}
		if("cordova" in window && window.cordova.plugins && window.cordova.plugins.SmartlookPlugin && window.cordova.plugins.SmartlookPlugin){
			window.cordova.plugins.SmartlookPlugin.setUserIdentifier({"identifier": userId,"sessionProperties": {"name": firstName,"surname":firstName, "email": userEmail}});
		}
		if(window.Raygun){
			Raygun.setUser(userId, false, userEmail, lastName, firstName);
		}
		if("RaygunNativePlugin" in window && userEmail){
			window.RaygunNativePlugin.startNativeRaygun(userId, window.RAYGUN_IOS_API_KEY); // This will be use in iOS context and will be ignore by android according to cordova doc
			if(window.RaygunNativePlugin.updateNativeLogs){
				window.RaygunNativePlugin.updateNativeLogs({"userId":userId,"userEmail":userEmail,"firstName":firstName,"lastName":lastName,"temporary":false});
			}
		}*/

		/*if(window.waitForCordovaToLoad){
			if("mixpanel" in window){
				mixpanel.reset(function(){},function(e){console.error(e)});
			}
		}else{
			MixpanelJS.reset();
		}*/
		if("MixpanelTrebbleHelper" in window){
			window.MixpanelTrebbleHelper.reset();
		}

		LiveChatWidgetHelper.getInstance().logout();
		
		if("SegmentJS" in window){
			window.SegmentJS.reset();
		}

		if("MParticleTrebbleHelper" in window){
			window.MParticleTrebbleHelper.logout();
		}
		
		
		if("cordova" in window && window.cordova.plugins && window.cordova.plugins.firebase && window.cordova.plugins.firebase.analytics){
			window.cordova.plugins.firebase.analytics.resetAnalyticsData();
		}
		if("FirebaseCrashlytics" in window ){
			var crashlytics = window.FirebaseCrashlytics.initialise();
			crashlytics.setUserIdentifier(null);
		}
		

		if(window.plugins && window.plugins.appsFlyer){
			window.plugins.appsFlyer.anonymizeUser(true);
		}
	}catch(err){
		console.error(err);
	}
}

const initRequestUserConsent = function(){
	try{
		window.consentData  = {};
		var promises =  [];
		if(window.waitForCordovaToLoad && window.consent){
			if(window.isIOSMobileDevice){
				promises.push(window.consent.trackingAuthorizationStatus().then((function(status){
					window.consentData.status = status;
				}).bind(this)))
				promises.push(window.consent.requestTrackingAuthorization().then((function(statusNew){
					window.consentData.status = statusNew
				}).bind(this)))
			}
			promises.push(window.consent.getConsentStatus().then((function(consentStatus){
				window.consentData.consentStatus = consentStatus;
				if (consentStatus === window.consent.ConsentStatus.Required) {
					return window.consent.requestInfoUpdate()
				}
			}).bind(this)))

			promises.push(window.consent.getFormStatus().then((function(formStatus){
				window.consentData.formStatus = formStatus;
				if (formStatus === window.consent.FormStatus.Available) {
					return window.consent.loadForm()
				}
			}).bind(this)).then((function(form){
				if(form){
					form.show()
				}

			}).bind(this)))

		}
		return RSVP.Promise.all(promises);
	}catch(error){
		console.error(error);
	}
}

window.checkIfReferralIsSuspicious =  function(){
    var isSuspicious = false;
    try{
        var suspiciousReferralIds = ['lizibeth'];
        var searchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(location.search));
        var viaParam = searchParams.get("via");
        isSuspicious = viaParam ? suspiciousReferralIds.includes(viaParam.toLowerCase()) : false;

    }catch(error){
        console.error(error);
    }
    if(isSuspicious){
        var errorMessage = "Something ain't right. Please try again later!";
        window.alertErrorMessage(errorMessage)
        throw errorMessage;
    }
}

// cordova device ready callback
const onDeviceReady = function() {
	window.log("onDeviceReady fireddd");
	if(!window._onDeviceReadyFired){
		window._onDeviceReadyFired = true;
		if(window.device.platform != "browser"){
			//this value must have been overritten by the background mode plugin so we will override this to browser to not break the rest of the Trebble code
			window.cordovaDevice = window.device;
			window.device = {"platform": "browser"};
			try{
				if('cordova' in window && window.cordova.plugins && window.cordova.plugins.backgroundMode){
					window.cordova.plugins.backgroundMode.disable();
					window.cordova.plugins.backgroundMode.setDefaults({ silent: true });
				}
			}catch(error){
				console.error(error);
			}
		}
		

		initRequestUserConsent();

		if("MixpanelTrebbleHelper" in window){
			window.MixpanelTrebbleHelper.init();
		}

		initInstallAttributionTracker();

		if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.USE_CUSTOM_LIST_PICKER_ON_IOS)){
			setupListenerOnSelectElementIfApplicable();
		}

		


		if("RaygunNativePlugin" in window && !window.Rollbar){
			try{
				window.RaygunNativePlugin.startNativeRaygun("anonymous_user", window.RAYGUN_IOS_API_KEY); // This will be use in iOS context and will be ignore by android according to cordova doc
			}catch(error){
				console.error(error);
			}
		}
		if(window.waitForCordovaToLoad){
			if("cordova" in window && window.cordova.InAppBrowser && window.cordova.InAppBrowser.open){
				window.openOrignalFunction = function(url, params){ 
					if(window.isIOSMobileDevice && window.cordova && window.cordova.InAppBrowser){
						window.cordova.InAppBrowser.open(url,params)}else{
							window.open(url, params)
						}
					};
					window.open = function(url,  windowName, windowFeatures){
						if(!windowFeatures){
							windowFeatures  = "";
							
						}
						windowFeatures  = windowFeatures +",toolbartranslucent=no,allowInlineMediaPlayback=yes,navigationbuttoncolor=#EC7F54,closebuttoncolor=#EC7F54,navigationbuttoncolor=#EC7F54";
						return window.cordova.InAppBrowser.open(url,windowName, windowFeatures)
					};
				}
			}

			if(window.ContextMenuState){
				try{
					//make sure to enable to context menu on ios
					window.ContextMenuState.setVisible(true);
				}catch(error){
					console.error(error);
				}
			}

			window._segmentSuperProps = {};

			initThirdPartyLibraries();

			if(window.device && window.device.platform == "browser"){
				if((!window.waitForCordovaToLoad || !window.useCordovaMediaPlugin) && !("Media" in window)){
					window.Media = function(){};
				}
				//window.alert = window.alertErrorMessage; 
				//$("body").addClass("ui-responsive-panel");
			}

			initDefaultWhichCanOnlyBeDetectedOnUserAction();

			window.checkIfReferralIsSuspicious();

			if(window.waitForCordovaToLoad){
				if(window.screen && window.screen.orientation && window.screen.orientation.lock && window.isIOSMobileDevice){
					window.screen.orientation.lock('portrait')
				}
			}

			//Setup UXCam is available
			if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.ENABLE_RECORDING_VIA_UXCAM)  && "UXCam" in window){
				var UXCAM_API_KEY = "h6vib0w0ovs32sr";
				var enableUXCAM = LocalStorageHelper.getInstance().getNumberOfDaysAppWasRan() < 3 ? true: false;// Enable UXCam only if the user has use the app less than 3 three times. This might also record for sessions for someone who have log out and log in after
				if(enableUXCAM){
					//Setup UXCam is available	
					window.UXCam.startWithKey(UXCAM_API_KEY);
				}
			}

			if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.ENABLE_RECORDING_VIA_SMARTLOOK_ANDROID) && "cordova" in window && window.cordova.plugins && window.cordova.plugins.SmartlookPlugin && window.cordova.plugins.SmartlookPlugin && !window.isIOSMobileDevice){
				window.cordova.plugins.SmartlookPlugin.setupAndStartRecording({smartlookAPIKey: window.SMART_LOOK_API_KEY});
			}




			LocalStorageHelper.getInstance().onAppStarted();

			var tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
			if(tokenInfo && LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor()){
				var userInfo = (tokenInfo && tokenInfo.userInfo) ? tokenInfo.userInfo : {};
				window.saveUserIdForTracking(userInfo._id, userInfo.email, userInfo.lastName, userInfo.firstName, userInfo.creationDate, userInfo); 
			}else{
				//window.trebbleAnalyticsHelper.setUserId((tokenInfo.userInfo.temporary && tokenInfo.userInfo.temporaryUserRandomId) ? tokenInfo.userInfo.username +"_"+ tokenInfo.userInfo.temporaryUserRandomId:  tokenInfo.userInfo.username);
				/*if(window.trebbleAnalyticsHelper){
					window.trebbleAnalyticsHelper.trebbleHelperSetTemporary(true, LocalStorageHelper.getInstance().getUniqueUserIdentifier());
				}*/
			}




			$(window).hashchange(saveJQMHistoryStack);
			$(window).hashchange(handleBrowserEntryPointHashChange);
			if(window.trebble.config.useSavedJQMHistory)
			{
				restorePreviousBrowserHistory();
			}
			if(window.device && window.device.platform != "Android"){
				setTimeout(function() {
					//document.body.style["background-color"]="rgba(17,17,17,1)";
					//document.body.style["border-color"]="rgba(17,17,17,17)";
					document.body.children[1].display = "none";
					if( navigator.splashscreen){
						navigator.splashscreen.hide();
					}
				}, 3000);
			}



			window.trackAppContext();
			if(window.trebbleAnalyticsHelper && window.trebbleAnalyticsHelper.trebbleHelperSetEventEmitter){
				window.trebbleAnalyticsHelper.trebbleHelperSetEventEmitter();
			}
			if(window.trebbleAnalyticsHelper){
				window.trebbleAnalyticsHelper.startTrackerWithId('UA-64269295-1');
				if(window.trebbleDeployVersion || window.trebbleAppVersion){
					window.trebbleAnalyticsHelper.trebbleHelperSetAppTimestampVersion(
						window.trebbleDeployVersion || window.trebbleAppVersion,
						window.trebbleBuildHash || window.trebbleAppVersion
					)
				}
			}

			$(document).on('pageinit',startAppOnJqueryMobileReady);
			
		}
	};

	const startAppOnJqueryMobileReady = function(){
		onmobileinit();
		if((window.location.hash.indexOf( window.trebble.popupLoginPageHash) == 1 || window.getPathNameWithoutHtmlPage().indexOf( window.trebble.popupLoginPageHash) == 1) && window.opener && window.opener.document && (window.location.hash || window.getPathNameWithoutHtmlPage()) ){
			window.log("doing  login only");
			window.trebble.isEmbededLoginInPage = true;
			window.trebble.allowEasySignupForListenersAtLogin = true;
			//Since this is an embedded page which probably opening a login popup, set an access code to allow user to login
			window.trebble.presetAccessCode = FREE_ACCESS_CODE_FOR_USER_WHO_DISCOVER_TREBBLE_VIA_SHARED_LINK;
			if(redirectHostedBrowserAuthCodeToCallbackIfApplicable()){
				return;
			}
			doLogingOnly(window.location.href);

		}else{
			window.log("normal startup");
			if(redirectHostedBrowserAuthCodeToCallbackIfApplicable()){
				return;
			}
			if(!window.isEmbedded){
				//if(!window.isIOSMobileDevice || LocalStorageHelper.getInstance().isLoggedInUserManuallyAgreedToTurnOnNotification()){
				if(!window.isIOSMobileDevice || LocalStorageHelper.getInstance().getUserManuallyEnabledDisabledDailyFeedNotification()){
					if(LocalStorageHelper.getInstance().getUserManuallyEnabledDisabledDailyFeedNotification() !== false){
						require(["models/helper/PushNotificationHelper"], function(PushNotificationHelper){
							if(PushNotificationHelper.default.getInstance().isPushNotificationLibraryInstalled()){
								PushNotificationHelper.default.getInstance().initNativePushNotification();
							}
						});
					}
				}

			}
			presetProfileTypeForSignupIfApplicable();
            applyCouponIfApplicable();
			applyTemporaryTokenOrAccessCodePassedViaUrlIfApplicable().then(function(){
                if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
                    return TrebbleClientAPIHelper.getInstance().bootstrapWebSession();
                }
                if(window.waitForCordovaToLoad){
                    return TrebbleClientAPIHelper.getInstance().refreshStoredMobileSessionIfNeeded(false).catch(function(error){
                        console.warn("Unable to refresh the stored mobile auth session during startup:", error);
                        return null;
                    });
                }
                return RSVP.Promise.resolve();
            }).then(retrieveAllSongs.bind(this)).catch(retrieveAllSongs.bind(this));
		}
	}


    const onmobileinit = function(){
    window.log('Jquery Mobile Loaded');
    $.mobile.ajaxEnabled = false;
    $.mobile.pushStateEnabled = false;
    $.mobile.touchOverflowEnabled = false;
    $.mobile.defaultPageTransition = 'none';
    $.mobile.defaultDialogTransition = 'pop';
    $.mobile.transitionFallbacks.slide = 'none';
    $.mobile.transitionFallbacks.pop = 'none';
    $.mobile.ignoreContentEnabled = true;
    $.mobile.imaxTransitionWidth = "100px";
    $.mobile.page.prototype.options.domCache = true;
    $.mobile.hoverDelay = 0;
    $.mobile.buttonMarkup.hoverDelay = 0;
    $.mobile.phonegapNavigationEnabled = false;
    $.mobile.hashListeningEnabled = false;
    $.mobile.linkBindingEnabled = false;
    $.mobile.changePage.defaults.changeHash = false;

        //iosquirk for status bar
    if (navigator.userAgent.match(/(iPad.*|iPhone.*|iPod.*);.*CPU.*OS 7_\d/i)) {
        $("body").addClass("ios7");
        $("body").append('');
    }

};

if(window.waitForCordovaToLoad){
    document.addEventListener("deviceready", onDeviceReady, false);
}else{
    onDeviceReady();
}

document.addEventListener("onmobileinit", onmobileinit, false);

const onApplicationNativelyPaused= function(){
    if(window.device.platform == "iOS"){
            //window.plugins.backgroundjs.lockBackgroundTime();
    }
    if(window.trebbleAnalyticsHelper){
            //window.trebbleAnalyticsHelper.trackEvent("Application State", 'Application Going Background', 'Background', (new Date()).getTime());
    }
    
        var playerModel = PersistentModels.getInstance().getPlayer();
        if(playerModel){
            if(window.device && window.device.platform != "Android" && window.device && window.device.platform != "iOS" && playerModel){
                if(playerModel.isPlaying() && playerModel.isYoutubeVideoLoaded()){
                    playerModel.pauseAudio(true);
                    playerModel.playAudio(true);
                }

            }
            if(window.waitForCordovaToLoad){
                playerModel._updateLockScreen();
            }

        }

    

};
const onApplicationNativelyResumed= function(){
    if(window.device.platform == "iOS"){
            //window.plugins.backgroundjs.unlockBackgroundTime();
    }
    if(window.trebbleAnalyticsHelper){
            //window.trebbleAnalyticsHelper.trackEvent("Application State", 'Application Going Foreground', 'Foreground', (new Date()).getTime());
    }
    if(FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.SHOW_INTERSTITIAL_ADS)){
        
            var playerModel = PersistentModels.getInstance().getPlayer();
            if(playerModel){
                var displayInterstitialOnMobile = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_interstitials_in_app, false);
                var showVideoWhenAppGoesForeground = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_when_app_comes_foreground_show_video, false);  
                var showAdOnlyWhenAudioIsLoaded = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_when_app_comes_foreground_and_audio_is_loaded, false);  
                var showInterstitialWhenAppGoesForeground = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.show_when_app_comes_foreground, false);
                var muteAds = Rollout.getFeatureVariable(Rollout.FEATURES.SHOW_INTERSTITIAL_ADS, Rollout.FEATURES.SHOW_INTERSTITIAL_ADS.variables.mute_audio, false); 
                if(muteAds){
                    showVideoWhenAppGoesForeground = true;
                }
                if(window.waitForCordovaToLoad && displayInterstitialOnMobile && showInterstitialWhenAppGoesForeground  && (!showAdOnlyWhenAudioIsLoaded || playerModel.getPlaylist())){
                    AdHelper.getInstance().showInterstitialAd(showVideoWhenAppGoesForeground, muteAds);
                }
            }
        
    }
};
document.addEventListener("pause", onApplicationNativelyPaused, false);
document.addEventListener("resume", onApplicationNativelyResumed, false);

window.onAndroidRemoteControlPressed = function(action){
    
        var playerModel = PersistentModels.getInstance().getPlayer();
        if(playerModel){
            switch(action) {
            case "next":
                playerModel.playNextSongInPlaylist(true);
                break;
            case "previous":
                playerModel.playPreviousSongInPlaylist(true);
                break;
            case "play":
                if(!playerModel.isLoading()){
                //playerModel.stopAudioAndRelease();
                    playerModel.playAudio();
                }
                break;
            case "pause":
                if(!playerModel.isLoading()){
                    if (playerModel.isPlaying()) {
                        playerModel.pauseAudio();
                    }
                }
                break;
            case "playpause":
                if(!playerModel.isLoading()){
                    if (playerModel.isPlaying()) {
                        playerModel.pauseAudio();
                    } else {
                        playerModel.playAudio();
                    }
                }
                break;
            case "playyoutube":
                if(playerModel.isPlaying() && playerModel.isYoutubeVideoLoaded()){
                    playerModel.pauseAudio();
                    playerModel.playAudio();
                }
                break;
            }
        /*if(action == "next")
        {
            playerModel.playNextSongInPlaylist(true);
        }else{
            if(action  == "previous")
            {
                playerModel.playPreviousSongInPlaylist(true);
            }else{
                if(action == "playpause")
                {
                    if (playerModel.isPlaying()) {
                        playerModel.pauseAudio();
                    } else {
                        playerModel.playAudio();
                    }
                }else{
                    if(action == "playyoutube")
                    {
                        if(playerModel.isPlaying() && playerModel.isYoutubeVideoLoaded()){
                            playerModel.pauseAudio();
                            playerModel.playAudio();
                        }
                    }
                }else{
                    if(action  == "play"){
                        playerModel.playAudio();
                    }else{
                        if(action  == "pause"){
                            playerModel.pauseAudio();
                        }
                    }

                }
            }
        }*/
        }

};

try{
    if ('mediaSession' in navigator && navigator.mediaSession.setActionHandler) {
        navigator.mediaSession.setActionHandler('previoustrack', function() {
        // User clicked "Previous Track" media notification icon.
            
                var playerModel = PersistentModels.getInstance().getPlayer();
                if(playerModel){
                    playerModel.playPreviousSongInPlaylist(true);
                }
            
        });

        navigator.mediaSession.setActionHandler('nexttrack', function() {
        // User clicked "Next Track" media notification icon.
            
                var playerModel = PersistentModels.getInstance().getPlayer();
                if(playerModel){
                    playerModel.playNextSongInPlaylist(true);	
                }
            
        });
        navigator.mediaSession.setActionHandler('play', function() {
        // User clicked "Play" media notification icon.
            
                var playerModel = PersistentModels.getInstance().getPlayer();
                if(playerModel){
                    playerModel.playAudio();
                }
        
        });
        navigator.mediaSession.setActionHandler('pause', function() {
        // User clicked "Pause" media notification icon.
            
                var playerModel = PersistentModels.getInstance().getPlayer();
                if(playerModel){
                    playerModel.pauseAudio();
                }
            
        });
    }
}catch(e){
    console.error("Failed setting up media sesssion handlers. Error:" + e);
}

window.sendErrorToRaygun = function(errorMessage, critical){
        var expectedErrorInfo = _getExpectedErrorInfo(errorMessage);
        if (expectedErrorInfo.isExpected) {
            if(window.trackExpectedErrorSkippedRollbar){
                window.trackExpectedErrorSkippedRollbar(errorMessage, "sendErrorToRaygun");
            }
            return;
        }
        var normalizedErrorMessage = (typeof errorMessage === "string")
            ? errorMessage
            : (errorMessage && errorMessage.message ? errorMessage.message : String(errorMessage || ""));

        try{

            if(window.Raygun && !window.Rollbar && normalizedErrorMessage){
                window.Raygun.send(new Error(normalizedErrorMessage));
            }
        }catch(error){
            console.error("Failed sending error to Raygun" + error);
        }
            try{
            if(window.Rollbar && normalizedErrorMessage){
                let customData = {};
                if (window.MixpanelTrebbleHelper) {
                    const mixpanelReplayUrl = window.MixpanelTrebbleHelper.getSessionReplayUrl();
                    if (mixpanelReplayUrl) {
                        customData.mixpanelSessionReplayUrl = mixpanelReplayUrl;
                    }
                }
                if (window.FS && typeof window.FS.getCurrentSessionURL === 'function') {
                    const fullStorySessionUrl = window.FS.getCurrentSessionURL();
                    if (fullStorySessionUrl) {
                        customData.fullStorySessionUrl = fullStorySessionUrl;
                    }
                }
                if(critical){
                    window.Rollbar.critical(new Error(normalizedErrorMessage), customData);
                }else{
                    window.Rollbar.error(new Error(normalizedErrorMessage), customData);
                }
            }
        }catch(error){
            console.error("Failed sending error to Rollbar" + error);
        }
        try{
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("ErrorCollection", "ErrorCollection", "Error collected", null, {"errorMessage":errorMessage, "critical": critical});
            } 
        }catch(error){
            console.error("Failed sending error to mpanel" + error);
        }
    }

		

	


	
